/* eslint-disable */
import React, { Component } from 'react';
import renderHTML from 'react-render-html';
import AppWrapper from '../../app-wrapper';
import ViewHeader from '../../components/view-header';
import FloatingCta from '../../components/floating-cta';
import CustomerAttributes from './ssm-components/customer-attributes/customer-attributes';
import SummaryDetails from './ssm-components/summary-details/summary-details';
import DeliveryAddress from './ssm-components/delivery-address/delivery-address';
import FormError from '../../components/form/error/error';
import './ssm-homepage.css';
import {
  stripStartingAndEndingPTags,
  prepareConfirmOrderDataOnApplicationLoad,
  getNewConfirmOrderForLineItemClick,
  getNewConfirmOrderForAllItemClick,
  prepareServiceUsageDataOnApplicationLoad,
  getUpdatedServiceUsageData,
  prepareContactSitesDataOnApplicationLoad,
  prepareDeliveryAddressForSitesOnApplicationLoad,
  getFullCombinedAddress,
  getAddressSearchResult,
  getAddressDetails,
  getSuggestedAddressList,
  getUpdatedDeliveryAddressData,
  getUpdatedDeliveryAddressDataUsingSuggestedAddresses,
  getPortTypeValue,
  prepareErrorMessageDataForContactSiteOnApplicatioLoad,
  validateContactSiteFormFields,
  confirmOrderDataAndUsageValidation,
  validateSiteContactFormFieldsOnSubmit,
  scrollElementIntoView,
  scrollFirstMatchingElementIntoView,
  prepareSSMRedirectTypeOnApplicationLoad,
  getUpdatedRedirectTypeData,
  prepareSSMRedirectNumberDataOnApplicationLoad,
  validateNumber,
  prepareSSMRedirectNumberErrorDataOnApplicationLoad,
  validatePhoneNumber,
  prepareSSMRedirectTypeDataOnApplicationLoad,
  validateDropDown,
  prepareServiceUsageErrorDataOnApplicationLoad,
  prepareSSMNameDisplayrDataOnApplicationLoad,
  prepareServiceTermDevicesQuantityDataForSitesOnApplicationLoad,
  prepareServiceTermConnectionDateForSitesOnApplicationLoad,
  prepareOrderSummaryDataForSitesOnApplicationLoad,
  updateOrderSummaryAfterServiceTableChanges,
  getIsdnRedirectCancelChecksData,
  prepareIsdnGoToOptionsSelections,
  validateRedirectCancelSelectionForSite,
  checkSiteContactFieldsErrors,
  prepareSitesBillingAccountNumbers,
  prepareISDNSubmitCustomerData,
  getNextInValidSite,
  getNoOfPhoneAndAnalogDevicesSiteErrors,
  getZeroErrorForMigrationCountForSite,
  setFirstErrorSectionIntoView,
  prepareSitesBsipCallingPlan,
  prepareSitesBsipContractMonthsSelection,
  getNumberOfTrunks,
  getNumberOfTelephoneNumbers,
  submitIsdnRequestCallback,
  prepareIsdnCallbackData,
  getInDialNumberRangesCount,
  scrollMatchingElementIntoView,
  getInDialServiceNumberList,
  getSavedDataObjects,
  validateInDialNumerDetailingTable,
  validateRedirectCancelSelectionForInDialSite,
  getNumberOfTrunksInDial,
  getInDialNumberBlocksCount,
  getSipConnectdevice,
  validateSipConnect,
  getSipConnectDeviceName,
  getSipConnectNumberOfTrunks,
  prepareSitesSIPInDialMigrateToEnterpriseTrunk,
  validateSipConnectEnterpriseTrunk,
} from './ssm-homepage.actions';
import SelectionOption from './ssm-components/selection-option/selection-option';
import IsdnServiceDetails from './ssm-components/isdn-service-details/isdn-service-details';
import ISDNRedirectServiceDetails from './ssm-components/isdn-redirect-service-details/isdn-redirect-service-details';
import ServiceTerm from './ssm-components/service-term/service-term';
import BsipServiceTerm from './ssm-components/bsip-service-term/bsip-service-term';
import SipConnectServiceTerm from './ssm-components/sip-connect-service-term/sip-connect-service-term';
import BsipCallingPlan from './ssm-components/bsip-calling-plan/bsip-calling-plan';
import BSIPServiceDetails from './ssm-components/bsip-service-details/bsip-service-details';
import SIPConnectServiceDetails from './ssm-components/sip-connect-service-details/sip-connect-service-details';
import ReviewNextSite from './ssm-components/review-next-site/review-next-site';
import OrderSummaryTable from './ssm-components/order-summary-table/order-summary-table';
import ConfirmSiteModal from './ssm-components/confirm-site-modal/confirm-site-modal';
import AlreadySubmittedModal from './ssm-components/already-submitted-modal/already-submitted-modal';
import RequestCallBackModalOffline from './ssm-components/request-callback-modal/request-callback-modal-offline';
import RequestCallBackModalOnline from './ssm-components/request-callback-modal/request-callback-modal-online';
import InDialNumberDetailTable from './ssm-components/indial-number-detail-table/indial-number-detail-table';
import IsdnInDialBsipServiceDetalis from './ssm-components/isdn-inDial-bsip-service-details/isdn-inDial-bsip-service-details';
import IsdnInDialTiptServiceDetalis from './ssm-components/isdn-inDial-tipt-service-details/isdn-inDial-tipt-service-details';
import IsdnInDialSipConnectServiceDetalis from './ssm-components/isdn-inDial-sip-connect-service-details/isdn-inDial-sip-connect-service-details';
import SIPConnectNetworkConnectionDevice from  './ssm-components/sip-connect-network-connection-device/sip-connect-network-connection-device';
import {
  PORT_TYPE_P_PHONE,
  RADIO_BUTTON_CONFIRM_ID,
  RADIO_BUTTON_REVIEW_ID,
  SERVICE_TERM_PURCHASE_RADIO_BUTTON,
  SSM_REVIEW_SERVICES_VIEW,
  SSM_ORDER_SUMMARY_VIEW,
  ORDER_READY_FOR_SUBMISSION_STATUS,
  ORDER_REVIEW_STATUS,
  ORDER_PARTIALLY_SAVED_STATUS,
  SERVICE_TERM_DEVICE_TYPE_FEATURESPACKS,
  SERVICE_TERM_DEVICE_TYPE_HANDSETS,
  SERVICE_TERM_DEVICE_TYPE_POWERPACKS,
  SERVICE_TERM_DEVICE_TYPE_HEADSET,
  SERVICE_TERM_DEVICE_TYPE_INTEGRATEDACCESSDEVICES,
  SERVICE_TERM_DEVICE_TYPE_CALLCENTER,
  PAYMENT_TYPE_MONTHLY,
  PAYMENT_TYPE_ONEOFF,
  ISDN_GOTOOPTION_MIGRATE_ALL_TIPT,
  ISDN_GOTOOPTION_REDIRECT_OR_CANCEL,
  ISDN_GOTOOPTION_MIGRATE_ALL_BSIP,
  BSIP_SERVICE_TERM_DEVICE_TYPE_FEATURESPACKS,
  BSIP_SERVICE_TERM_DEVICE_TYPE_NUMBER_CHARGES,
  BSIP_SERVICE_TERM_DEVICE_TYPE_CALLING_PLAN,
  BSIP_SERVICE_TERM_DEVICE_TYPE_NTU,
  AUTO_SAVE_TIMER_COUNT,
  AUTO_SAVE_STATUS_SAVING,
  DEBUG_MODE,
  SITE_STATUS_PARTIALLY_SAVED,
  SITE_STATUS_SUBMITTED,
  ISDN_GOTOOPTION_MIGRATE_ALL_SIP_CONNECT,
  SIP_CONNECT_SERVICE_TERM_DEVICE_TYPE_ESTABLISHMENT_FEES,
  SIP_CALLING_PLAN_SELECT_OPTION,
  SIP_CONNECT_NETWORK_DEVICE_SELECT_OPTION,
  SITE_CONTACT_FIRST_NAME,
  SITE_CONTACT_LAST_NAME,
  SITE_CONTACT_EMAIL,
  MIGRATE_TO_ENTERPRISE_TRUNK,
} from '../../app-constants';
import { ShowUnTouchedProvider } from './context';
import SiteDetails from './ssm-components/site-details/site-details';
import Loader from '../../components/loader';
import Button from '../../components/button/button';
import AutoSaveMessage from './ssm-components/auto-save-message/auto-save-message';
import { createOmnitureDataLayerForSSM, omnitureTriggerEventAction, omnitureTriggerComponentActionForSSM } from '../../utilities/omniture-data-layer';
import InDialNumberDetailing from "./ssm-components/in-dial-number-detailing/in-dial-number-detailing";
import IsdnInDialRedirectServiceDetails from './ssm-components/isdn-inDial-redirect-service-details/isdn-inDial-redirect-service-details';
import SipCallingPlan from './ssm-components/sip-calling-plan/sip-calling-plan';
import { updateLiveChatValues, showHideOldNewHeaderFooter } from '../../app-actions';

class SSMHomePageView extends Component {
  state = {
    confirmChangesOptions: {
      radioButtons: [
        { id: RADIO_BUTTON_CONFIRM_ID, checked: false },
        { id: RADIO_BUTTON_REVIEW_ID, checked: false },
      ],
    },
    isdnGoToOptionButtons: {
      radioButtons: [
        { id: ISDN_GOTOOPTION_MIGRATE_ALL_TIPT, checked: true },
        { id: ISDN_GOTOOPTION_REDIRECT_OR_CANCEL, checked: false },
      ],
    },
    isdnRedirectCancelChecks: {},
    isdnRedirectNumberData: {},
    isdnRedirectTypeData: {},
    isdnRedirectNumberFieldError: {},
    isdnRedirectTypeFieldError: {},
    isdnGoToOptions: [],
    currentView: SSM_REVIEW_SERVICES_VIEW,
    serviceTermSelectedOption: SERVICE_TERM_PURCHASE_RADIO_BUTTON,
    selectionOption: '',
    siteAddressSelected: '',
    confirmChangesSelected: false,
    selectedSiteId: this.props.dataLoaded ? this.props.sitesData[0].siteId : '',
    confirmOrderData: [], // this will hold the selections of radiobuttons (migrate/cancel) for service items rows.
    serviceTermDeviceQuantityData: [],
    serviceTermConnectionDateData: [],
    orderSummaryData: [],
    customerBillingAccountNumber: '',
    serviceUsageData: [], // this will hold the selections of usage dropdown for service item rows.
    formFields: [], // this will hold contact site details of different sites,
    deliveryAddressesData: [], // this will hold the delivery address for each site.
    showUpdateDeliveryAddressSection: false,
    contactSiteFieldsHasErrors: [], // this holds whether contact site form fields has validation error
    redirectNumberFieldErrors: {}, // this holds redirect Number Errors Data
    redirectTypeFieldErrors: {}, // this holds redirect type Errors Data
    serviceUsageTypeFieldErrors: {}, // this holds usage dropdown selection errors Data
    showServicesErrorMessage: false,
    showSiteContactErrorMessage: false,
    addressSearch: {
      allowNew: false,
      isLoading: false,
      multiple: false,
      options: [],
      selectedAddress: '',
      selectedAddressId: '',
      selected: [],
      showSuggestedAddressList: false,
      suggestedAddressList: [],
      suggestedAddressSelectedValue: '',
      addressVerificationInProcess: false,
      showAddressUpdateCompletedMessage: false,
    },
    migrationCounts: {},
    migrationCountErrors: {},
    migrationCountBothZeroErrors: {},
    sitesBillingAccountNumber: {},
    formSubmitted: false,
    siteReviewed: false,
    siteProcessed: {},
    sitesBsipCallingPlanSelection: {},
    sitesBsipContractMonthsData: {},
    sitesSipContractMonthsData: {},
    // This data is currently hard-coded but should be moved to AEM contribution
    serviceProductsArray: [
      {
        ...this.props.authorableContent.serviceTerm.featuresPacks,
        deviceType: SERVICE_TERM_DEVICE_TYPE_FEATURESPACKS,
        paymentType: PAYMENT_TYPE_MONTHLY,
        readOnlyQuantities: { basicFeaturePack: 'numberOfAnalogue', standardFeaturePack: 'numberOfPhones', liberateMobilePack: 'numberOfMobiles' },
      },
      {
        ...this.props.authorableContent.serviceTerm.handsets,
        deviceType: SERVICE_TERM_DEVICE_TYPE_HANDSETS,
        paymentType: '',
        readOnlyQuantities: { polycomVVX411: 'numberOfPhones' },
      },
      {
        ...this.props.authorableContent.serviceTerm.powerPacks,
        deviceType: SERVICE_TERM_DEVICE_TYPE_POWERPACKS,
        paymentType: PAYMENT_TYPE_ONEOFF,
        readOnlyQuantities: {},
      },
      {
        ...this.props.authorableContent.serviceTerm.headset,
        deviceType: SERVICE_TERM_DEVICE_TYPE_HEADSET,
        paymentType: PAYMENT_TYPE_ONEOFF,
        readOnlyQuantities: {},
      },
      {
        ...this.props.authorableContent.serviceTerm.integratedAccessDevices,
        deviceType: SERVICE_TERM_DEVICE_TYPE_INTEGRATEDACCESSDEVICES,
        paymentType: '',
        readOnlyQuantities: { fxs2PortIAD: 'analogueTwo', fxs8PortIAD: 'analogueEight' },
      },
      {
        ...this.props.authorableContent.serviceTerm.callCenter,
        deviceType: SERVICE_TERM_DEVICE_TYPE_CALLCENTER,
        paymentType: PAYMENT_TYPE_MONTHLY,
        readOnlyQuantities: {
          mireception: 'mireception',
          callcenteragentstandard: 'callcenteragentstandard',
          callcenteragentpremium: 'callcenteragentpremium',
          callcentersupervisorstandard: 'callcentersupervisorstandard',
          callcentersupervisorpremium: 'callcentersupervisorpremium',
          mireceptioncallcenteragentstandard: 'mireceptioncallcenteragentstandard'
        },
      }
    ],
    bsipServiceProductsArray: [
      {
        ...this.props.authorableContent.bsipServiceTerm.featuresPacks,
        deviceType: BSIP_SERVICE_TERM_DEVICE_TYPE_FEATURESPACKS,
        paymentType: PAYMENT_TYPE_MONTHLY,
        readOnlyQuantities: false,
      },
      {
        ...this.props.authorableContent.bsipServiceTerm.numberCharges,
        deviceType: BSIP_SERVICE_TERM_DEVICE_TYPE_NUMBER_CHARGES,
        paymentType: PAYMENT_TYPE_MONTHLY,
        readOnlyQuantities: true,
      },
      {
        ...this.props.authorableContent.bsipServiceTerm.callingPlan,
        deviceType: BSIP_SERVICE_TERM_DEVICE_TYPE_CALLING_PLAN,
        paymentType: PAYMENT_TYPE_MONTHLY,
        readOnlyQuantities: true,
      },
      {
        ...this.props.authorableContent.bsipServiceTerm.ntu,
        deviceType: BSIP_SERVICE_TERM_DEVICE_TYPE_NTU,
        paymentType: PAYMENT_TYPE_MONTHLY,
        readOnlyQuantities: true,
      },
    ],
    sipConnectServiceProductsArray: [
      {
        ...this.props.authorableContent.sipConnectServiceTerm.featuresPacks,
        deviceType: BSIP_SERVICE_TERM_DEVICE_TYPE_FEATURESPACKS,
        paymentType: PAYMENT_TYPE_MONTHLY,
        readOnlyQuantities: false,
      },
      {
        ...this.props.authorableContent.sipConnectServiceTerm.establishmentFees,
        deviceType: SIP_CONNECT_SERVICE_TERM_DEVICE_TYPE_ESTABLISHMENT_FEES,
        paymentType: PAYMENT_TYPE_ONEOFF,
        readOnlyQuantities: true,
      },
      {
        ...this.props.authorableContent.sipConnectServiceTerm.callingPlan,
        deviceType: BSIP_SERVICE_TERM_DEVICE_TYPE_CALLING_PLAN,
        paymentType: PAYMENT_TYPE_MONTHLY,
        readOnlyQuantities: true,
      },
      {
        ...this.props.authorableContent.sipConnectServiceTerm.integratedAccessDevices,
        deviceType: SERVICE_TERM_DEVICE_TYPE_INTEGRATEDACCESSDEVICES,
        paymentType: PAYMENT_TYPE_ONEOFF,
        readOnlyQuantities: true,
      }
    ],
    migrationAdvertiseChecks: {},
    confirmSiteModalIsOpen: false,
    confirmSiteCheckBoxChecked: false,
    sitesConfirmedList: [],
    formSubmissionInProcess: false,
    siteFormSubmitted: this.props.siteFormSubmitted || false,
    callBackRequestLiveChatOfflineModalIsOpen: false,
    callBackRequestLiveChatOnlineModalIsOpen: false,
    callBackRequestCompleted: false,
    callBackPhoneNumber: '',
    IsCallBackPhoneNumberhasError: false,
    dataSavedTime: null,
    alreadySubmittedModalIsOpen: false,
    siteStatusData: {},
    inDialServiceNumberData: {},
    inDialServiceNumberErrorData: {},
    inDialUserNamesData: {},
    inDialUserTypeData: {},
    isdnInDialBsipServiceMigrateCancelCheckList: {},
    isdnInDialBsipServiceMigrateAllCheck: false,
    isdnInDialTiptServiceMigrateCancelCheckList: {},
    isdnInDialTiptServiceMigrateAllCheck: false,
    inDialDetailingShowMoreText : false,
    isdnInDialServiceRedirectCancelCheckList: {},
    isdnInDialServiceRedirectAllCheck: false,
    isdnInDialRedirectServiceCancelAllCheck: false,
    isdnInDialRedirectTypeData: {},
    isdnInDialRedirectNumberData: {},
    isdnInDialRedirectNumberFieldError: {},
    isdnInDialBsipServiceHasError: false,
    isdnInDialTiptServiceHasError: false,
    sipInclusionShowList: false,
    sitesSipConnectNumberOfTrunks : {},
    sitesSipConnectPabxVendor: {},
    sitesSipConnectPabxModel: {},
    sitesSIPInDialMigrateToEnterpriseTrunk : {},
    sitesSIPInDialMigrateToEnterpriseTrunkSelection : {},
    sitesEnterpriseTrunkOptions : [],
    sitesEnterpriseTrunkValidationTracking:{},
    enterpriseTrunkingRequestCallBackForSites: {}
  };

  componentDidMount = () => {
    showHideOldNewHeaderFooter(false);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.dataLoaded !== this.props.dataLoaded && this.props.dataLoaded && this.props.siteFormSubmitted === false) {
      this.setCallbackPhonenumber(this.props.customerContactPhone);
      this.setInitialSiteAddressAndSiteId(this.props.sitesData);
      this.updateConfirmOrderData(prepareConfirmOrderDataOnApplicationLoad(this.props.sitesData));
      this.updateServiceUsageData(prepareServiceUsageDataOnApplicationLoad(this.props.sitesData));
      this.updateServiceUsageErrorData(prepareServiceUsageErrorDataOnApplicationLoad(this.props.sitesData));
      this.updateRedirectTypeData(prepareSSMRedirectTypeOnApplicationLoad(this.props.sitesData));
      this.updateRedirectNumberData(prepareSSMRedirectNumberDataOnApplicationLoad(this.props.sitesData));
      this.updateNameDisplay(prepareSSMNameDisplayrDataOnApplicationLoad(this.props.sitesData));
      this.updateRedirectTypeErrorData(prepareSSMRedirectTypeDataOnApplicationLoad(this.props.sitesData));
      this.updateRedirectNumberErrorData(prepareSSMRedirectNumberErrorDataOnApplicationLoad(this.props.sitesData));
      this.updateCustomerBillingAccountNumber(prepareSitesBillingAccountNumbers(this.props.sitesData, this.props.customerAccountNumbers[0]));
      this.updateOrderSummaryData(prepareOrderSummaryDataForSitesOnApplicationLoad(this.props.sitesData));
      this.updateReloadData(prepareSitesSIPInDialMigrateToEnterpriseTrunk(this.props.sitesData));
      this.setupAutoSaveTimer();
      createOmnitureDataLayerForSSM('custom-net', 'physical-virtual-services');
      this.updateReloadData(getSavedDataObjects(this.props.sitesData, this.props.authorableContent));
      updateLiveChatValues(this.props.authorableContent.liveChat, 'SSM');
    } 

    if (prevProps.siteFormSubmitted !== this.props.siteFormSubmitted && this.props.siteFormSubmitted) {
      this.addSiteToConfirmedList();
    }
  }

  updateReloadData = (reLoadData) => {
    if (DEBUG_MODE) {
      console.log('In Reload Data Function');
      console.log(reLoadData);
    }
    this.setState(reLoadData);
  }

  addSiteToConfirmedList = () => {
    const sitesConfirmedList = [...this.state.sitesConfirmedList, this.props.siteIdSubmitted];
    const siteStatusData = this.state.siteStatusData;
    siteStatusData[this.props.siteIdSubmitted] = SITE_STATUS_SUBMITTED;
    this.setState({sitesConfirmedList, siteStatusData, formSubmissionInProcess: false, siteFormSubmitted: true, confirmSiteCheckBoxChecked: false });
  }
  
  onCloseConfirmSiteModal = () => {
    this.setState({confirmSiteModalIsOpen: false, siteFormSubmitted: false, confirmSiteCheckBoxChecked: false});
  }

  onCloseAlreadySubmittedModal = () => {
    this.setState({alreadySubmittedModalIsOpen: false});
  }


  onCloseRequestCallBackOffline = () => {
    this.setState({callBackRequestLiveChatOfflineModalIsOpen: false, callBackRequestLiveChatOnlineModalIsOpen: false, callBackRequestCompleted: false });
  }

  onOpenRequestCallBack = () => {
    const isLiveChatAgentPresent = document.querySelector('.embeddedServiceHelpButton .helpButton .uiButton.helpButtonEnabled');
    if (isLiveChatAgentPresent) {
      this.setState({callBackRequestLiveChatOnlineModalIsOpen: true });  
    } else {
      this.setState({callBackRequestLiveChatOfflineModalIsOpen: true });  
    }
  }

  handleInDialUserNameOnChange = (event) => {
    const newInDialUserNamesData = this.state.inDialUserNamesData || {};
    newInDialUserNamesData[event.target.id] = event.target.value;
    this.setState({inDialUserNamesData: newInDialUserNamesData});
  };

  handleInDialUserNameOnBlur = (event) => {
    this.markSiteProcessed(this.state.selectedSiteId);
    const newInDialUserNamesData = this.state.inDialUserNamesData || {};
    newInDialUserNamesData[event.target.id] = event.target.value;
    this.setState({inDialUserNamesData: newInDialUserNamesData});
  };

  handleInDialUserTypeOnChange = (event) => {
    this.markSiteProcessed(this.state.selectedSiteId);
    const newinDialUserTypeData = this.state.inDialUserTypeData || {};
    newinDialUserTypeData[event.target.id] = event.target.value;
    this.setState({inDialUserTypeData: newinDialUserTypeData});
  };

  onAutoSaveHandler = () => {
    const { submitAutoSaveData } = this.props.actions;
    const { autoSaveStatus } = this.props;
    const isSiteProcessed = this.state.siteProcessed[this.state.selectedSiteId] !== undefined;
    const siteAlreadySubmitted =  this.state.sitesConfirmedList.includes(this.state.selectedSiteId);
    const siteToBeSubmitted = this.props.sitesData.filter(site => site.siteId === this.state.selectedSiteId);
    const authorableData = {
      ntuDefaultQuantity: this.props.authorableContent.bsipServiceTerm.ntuDefaultQuantity,
      inDialNumberDetailFirstName: this.props.authorableContent.inDialNumberDetailingSection.formFields.userFirstName.placeholder,
      inDialNumberDetailLasttName: this.props.authorableContent.inDialNumberDetailingSection.formFields.userLastName.placeholder,
      pabxVendor: this.props.authorableContent.inDialSipNetworkConnectionDevice.formFields.pabxVendor,
    };
    if (siteAlreadySubmitted === false && isSiteProcessed === true && autoSaveStatus !== AUTO_SAVE_STATUS_SAVING) {
      if(DEBUG_MODE) {
        console.log('auto save starting');
      }
      omnitureTriggerEventAction('formStep');
      const dataForSubmit = prepareISDNSubmitCustomerData(this.state, siteToBeSubmitted, authorableData);
      this.markSiteUnProcessed(this.state.selectedSiteId);
      submitAutoSaveData(dataForSubmit);
    }

  }

  onStartLiveChat = () => {
    this.setState({callBackRequestLiveChatOfflineModalIsOpen: false, callBackRequestLiveChatOnlineModalIsOpen: false, callBackRequestCompleted: false });
    const liveChatButton = document.querySelector('.embeddedServiceHelpButton .helpButton .uiButton.helpButtonEnabled');
    liveChatButton.click();

  }

  onOnlineRequestCallBack = () => {
    this.setState({ callBackRequestLiveChatOnlineModalIsOpen: false, callBackRequestLiveChatOfflineModalIsOpen: true });  
  }
  
  onRequestCallBackCompleted = () => {
    omnitureTriggerEventAction('requestCallback');
    const { submitIsdnRequestCallback } = this.props.actions;
    const { callBackPhoneNumber } = this.state;
    const { customerContactPhone } = this.props;
    const callBackData = prepareIsdnCallbackData(customerContactPhone !== callBackPhoneNumber ? callBackPhoneNumber : '');
    this.setState({callBackRequestCompleted: true });
    submitIsdnRequestCallback(callBackData);
  }

  onConfirmSiteCheckBoxChanged = ({ id, checked }) => {
    this.setState({confirmSiteCheckBoxChecked: checked})
  }

  onRadioButtonCallBackActionWithToggle = (radioButtonClicked) => {
    if (radioButtonClicked.id === RADIO_BUTTON_CONFIRM_ID) {
      const validationResult = this.validateIsdnConfirmAllRadioButtonClick();
      if (validationResult.siteContactErrorPresent ||
        validationResult.siteTableErrorPresent ||
        validationResult.sitePhonesAnalogueDevicesErrorPresent
      ) {
        this.resetConfirmChangesRadioButtonState();
        const fisrtInValidSiteObject = getNextInValidSite(this.props.sitesData, validationResult.sitesError);
        setTimeout(() => {
          this.updateSiteAddressDropDownSelection(fisrtInValidSiteObject);
        }, 50);
        setFirstErrorSectionIntoView(validationResult);
      }
      if (validationResult.siteContactErrorPresent) {
        this.setState({ showSiteContactErrorMessage: true });
      }
      if (validationResult.siteTableErrorPresent) {
        this.updateShowServiceMessageError(true);
      } else if (validationResult.sitePhonesAnalogueDevicesErrorPresent) {
        this.setState({ formSubmitted: true });
      } else {
        setTimeout(() => {
          this.setState({ showSiteContactErrorMessage: false, showServicesErrorMessage: false });
        }, 500);
        this.prepareConfirmChangesRadioButtonStateOnToggle(radioButtonClicked);
      }
    } else {
      setTimeout(() => {
        this.setState({ showSiteContactErrorMessage: false, showServicesErrorMessage: false });
      }, 500);
      this.prepareConfirmChangesRadioButtonStateOnToggle(radioButtonClicked);
    }
  };

  onISDNRadioButtonCallBackActionWithToggle = (radioButtonClicked) => {
    this.prepareISDNGoToOptionsRadioButtonStateOnToggle(radioButtonClicked);
  };

  onServiceDetailRadioButtonChange = (radioButtonClicked) => {
    let newConfirmOrderData;
    if (radioButtonClicked.id.includes('all') === false) {
      newConfirmOrderData = getNewConfirmOrderForLineItemClick(this.state.confirmOrderData, radioButtonClicked.id, this.props.sitesData);
    } else {
      newConfirmOrderData = getNewConfirmOrderForAllItemClick(this.state.confirmOrderData, radioButtonClicked.id);
    }
    const confirmRadioButton = this.state.confirmChangesOptions.radioButtons.filter(radioButton => radioButton.id === RADIO_BUTTON_CONFIRM_ID)[0];
    if (((radioButtonClicked.id.includes('redirect')) || (radioButtonClicked.id.includes('migrate') &&
    getPortTypeValue(radioButtonClicked, this.props.sitesData).toUpperCase() !== PORT_TYPE_P_PHONE))
      && confirmRadioButton.checked) {
      const newMigrateCancelRadioButtonOptions = this.state.confirmChangesOptions.radioButtons
        .map(radioButton => ({ ...radioButton, checked: !confirmRadioButton.checked }));
      this.updateConfirmChangesRadioButtonState(newMigrateCancelRadioButtonOptions, !confirmRadioButton.checked);
    }

    const currentConnectionDataObject =
      this.state.serviceTermConnectionDateData.filter(connectionData => connectionData.siteId === this.state.selectedSiteId)[0];
    const newServiceTermConnectionDateData =
      this.state.serviceTermConnectionDateData.filter(connectionData => connectionData.siteId !== this.state.selectedSiteId);
    if (radioButtonClicked.id.includes('migrate') && currentConnectionDataObject.purchaseRentalSelectedOption === null) {
      currentConnectionDataObject.purchaseRentalSelectedOption = SERVICE_TERM_PURCHASE_RADIO_BUTTON;
    }
    newServiceTermConnectionDateData.push(currentConnectionDataObject);

    this.setState(
      {
        confirmOrderData: newConfirmOrderData,
        serviceTermConnectionDateData: newServiceTermConnectionDateData,
      });
  };

  onServiceTermRadioButtonsClicked = (radioButtonClicked) => {
    omnitureTriggerEventAction(`service term selected ${radioButtonClicked.id}`);
    this.markSiteProcessed(this.state.selectedSiteId);
    const selectedConnectionDateDateObject = this.state.serviceTermConnectionDateData
      .filter(connectionData => connectionData.siteId === this.state.selectedSiteId)[0];
    const newServiceTermConnectionDateData =
      this.state.serviceTermConnectionDateData.filter(connectionData => connectionData.siteId !== this.state.selectedSiteId);
    newServiceTermConnectionDateData.push({
      siteId: this.state.selectedSiteId,
      connectionDate: selectedConnectionDateDateObject.connectionDate,
      purchaseRentalSelectedOption: radioButtonClicked.id,
    });

    this.setState({ serviceTermSelectedOption: radioButtonClicked.id, serviceTermConnectionDateData: newServiceTermConnectionDateData });
  };

  onServiceDetailUsageSelectionBlur = (event) => {
    const serviceUsageTypeFieldErrors = { ...this.state.serviceUsageTypeFieldErrors, [event.target.id]: !validateDropDown(event.target.value) };
    this.updateServiceUsageErrorData(serviceUsageTypeFieldErrors);
    this.updateServiceUsageData(getUpdatedServiceUsageData(this.state.serviceUsageData, event.target));
  };

  onRedirectTypeSelectionBlur = (event) => {
    const redirectTypeFieldErrors = { ...this.state.redirectTypeFieldErrors, [event.target.id]: !validateDropDown(event.target.value) };
    this.updateRedirectTypeErrorData(redirectTypeFieldErrors);
    this.updateRedirectTypeData(getUpdatedRedirectTypeData(this.state.redirectTypeData, event.target));
  };

  onSiteAddressListBlur= (event) => {
    const selectedSiteData = this.props.sitesData.filter(siteData => getFullCombinedAddress(siteData) === event.target.value)[0];
    this.updateSiteAddressDropDownSelection(selectedSiteData);
  };

  setInitialSiteAddressAndSiteId = (sitesData) => {
    this.setState({ siteAddressSelected: getFullCombinedAddress(sitesData[0]),
      selectedSiteId: sitesData[0].siteId });
  };

  markSiteProcessed = (siteId) => {
    const siteProcessed = this.state.siteProcessed;
    if (siteId.length > 0 && siteProcessed[siteId] === undefined) {
      siteProcessed[siteId] = true;
      setTimeout(() => {
        this.setState({ siteProcessed });
      }, 1000);
    }
  };

  markSiteUnProcessed = (siteId) => {
    const siteProcessed = this.state.siteProcessed;
    delete siteProcessed[siteId];
    const siteStatusData = this.state.siteStatusData;
    siteStatusData[siteId] = SITE_STATUS_PARTIALLY_SAVED;
    const newDataSaveTime = new Date();
    setTimeout(() => {
      this.setState({ siteProcessed, siteStatusData, dataSavedTime: newDataSaveTime });
    }, 1000);
  };


  handlePhoneCountChange = (event) => {
    this.markSiteProcessed(this.state.selectedSiteId);
    if (event.target.value.length < 11 && validateNumber(event.target.value)) {
      const migrationCounts = { ...this.state.migrationCounts };
      migrationCounts[event.target.id] = event.target.value;
      this.setState({ migrationCounts });
    }
  }

  handlePhoneCountBlur = (event) => {
    omnitureTriggerEventAction('mobileNumberEntered');
    this.markSiteProcessed(this.state.selectedSiteId);
    const migrationCountErrors = { ...this.state.migrationCountErrors };
    if (event.target.value.length < 1) {
      migrationCountErrors[event.target.id] = true;
    } else {
      migrationCountErrors[event.target.id] = false;
    }
    this.setState({ migrationCountErrors });
  }

  handleMigrationCheckboxChange = ({ id, checked }) => {
    this.markSiteProcessed(this.state.selectedSiteId);
    const migrationAdvertiseChecks = this.state.migrationAdvertiseChecks;
    migrationAdvertiseChecks[id] = checked;
    this.setState({ migrationAdvertiseChecks });
  }

  proceedToNextSite = () => {
    let currentIndex = 0;
    this.props.sitesData.forEach((element, index) => {
      if (element.siteId === this.state.selectedSiteId) {
        currentIndex = index;
      }
    });

    scrollElementIntoView('site-details-heading');

    // Wait 0.5 Seconds before update
    setTimeout(() => {
      let newSiteData = {};
      if (currentIndex + 1 < this.props.sitesData.length) {
        newSiteData = this.props.sitesData[currentIndex + 1];
      } else {
        newSiteData = this.props.sitesData[0];
      }
      this.updateSiteAddressDropDownSelection(newSiteData);
    }, 500);

  }

  setupAutoSaveTimer = () => {
    const timeInMilliSeconds = (parseInt(AUTO_SAVE_TIMER_COUNT, 10) * 60 * 1000);
    setInterval(() => {
      this.onAutoSaveHandler();
    },timeInMilliSeconds);
  }

  updateSiteAddressDropDownSelection = (selectedSiteData) => {
    const newSelectedSiteId = selectedSiteData.siteId;
    const newSelectedAddress = getFullCombinedAddress(selectedSiteData);
    const currentConnectionDataObject =
      this.state.serviceTermConnectionDateData.filter(connectionData => connectionData.siteId === this.state.selectedSiteId)[0];
    this.onAutoSaveHandler();
    this.setState({
      selectedSiteId: newSelectedSiteId,
      currentView: SSM_REVIEW_SERVICES_VIEW,
      siteAddressSelected: newSelectedAddress,
      showUpdateDeliveryAddressSection: false,
      serviceTermSelectedOption: currentConnectionDataObject.purchaseRentalSelectedOption,
      siteReviewed: false,
      confirmSiteModalIsOpen: false,
      siteFormSubmitted: false,
    });
    omnitureTriggerEventAction('addressEntered');
    this.handleClearSearch();
  };


  validateConfirmAllRadioButtonClick = () => {
    const { confirmOrderDataAndUsageValidationData,
      redirectTypeFieldErrors, serviceUsageTypeFieldErrors,
      redirectNumberFieldErrors } = confirmOrderDataAndUsageValidation(this.props.sitesData, this.state);
    this.updateRedirectTypeErrorData(redirectTypeFieldErrors);
    this.updateServiceUsageErrorData(serviceUsageTypeFieldErrors);
    this.updateRedirectNumberErrorData(redirectNumberFieldErrors);
    return (confirmOrderDataAndUsageValidationData.every(value => !value));
  };

  validateIsdnConfirmAllRadioButtonClick = () => {
    const sitesContactError = {};
    const siteServiceTableError = {};
    const sitePhoneAnalogueDevicesError = {};
    this.props.sitesData.forEach((siteData) => {
      sitesContactError[`${siteData.siteId}`] = !checkSiteContactFieldsErrors(this.state.contactSiteFieldsHasErrors, siteData.siteId);
      const isdnOptionSelectedSite = this.state.isdnGoToOptions.find(isdnOption => isdnOption.siteId === siteData.siteId);
      const migrateAllToTiptRadioButtonChecked = isdnOptionSelectedSite && isdnOptionSelectedSite.isdnGoTo === ISDN_GOTOOPTION_MIGRATE_ALL_TIPT;
      const migrateAllToBsipRadioButtonChecked = isdnOptionSelectedSite && isdnOptionSelectedSite.isdnGoTo === ISDN_GOTOOPTION_MIGRATE_ALL_BSIP;
      siteServiceTableError[`${siteData.siteId}`] = migrateAllToTiptRadioButtonChecked || migrateAllToBsipRadioButtonChecked ? false :
        !validateRedirectCancelSelectionForSite(siteData.siteServices, this.state.isdnRedirectCancelChecks,
          this.state.isdnRedirectNumberData, this.state.isdnRedirectTypeData);
      if (migrateAllToTiptRadioButtonChecked) {
        sitePhoneAnalogueDevicesError[`${siteData.siteId}`] =
          getNoOfPhoneAndAnalogDevicesSiteErrors(siteData.siteId, this.state.migrationCountErrors, this.state.migrationCounts)
          || getZeroErrorForMigrationCountForSite(siteData.siteId, this.state.migrationCounts);
      }
    });
    let siteContactErrorPresent = false;
    Object.keys(sitesContactError).forEach((site) => {
      siteContactErrorPresent = siteContactErrorPresent || sitesContactError[site];
    });
    let siteTableErrorPresent = false;
    Object.keys(siteServiceTableError).forEach((site) => {
      siteTableErrorPresent = siteTableErrorPresent || siteServiceTableError[site];
    });
    let sitePhonesAnalogueDevicesErrorPresent = false;
    Object.keys(sitePhoneAnalogueDevicesError).forEach((site) => {
      sitePhonesAnalogueDevicesErrorPresent = sitePhonesAnalogueDevicesErrorPresent || sitePhoneAnalogueDevicesError[site];
    });

    const sitesError = {};
    this.props.sitesData.forEach((siteData) => {
      sitesError[`${siteData.siteId}`] = (
        sitesContactError[`${siteData.siteId}`] ||
        siteServiceTableError[`${siteData.siteId}`] ||
        sitePhoneAnalogueDevicesError[`${siteData.siteId}`]
      );
    });
    return {
      siteContactErrorPresent,
      siteTableErrorPresent,
      sitePhonesAnalogueDevicesErrorPresent,
      sitesError,
    };
  };

  handleClearSearch = () => {
    const { addressSearch } = this.state;
    this.setState({
      addressSearch: {
        ...addressSearch,
        selected: [],
        suggestedAddressList: [],
        showSuggestedAddressList: false,
        showAddressUpdateCompletedMessage: false,
      },
      isLoadingAddressDetails: false,
    });
  };

  handleUpdateDeliveryAddress = () => {
    omnitureTriggerEventAction('delivery address update link clicked');
    this.markSiteProcessed(this.state.selectedSiteId);
    this.setState({ showUpdateDeliveryAddressSection: true });
  };

  handleSubmit = () => {
    const { submitSSMCustomerData } = this.props.actions;
    this.setState({formSubmissionInProcess: true });
    const authorableData = {
      ntuDefaultQuantity: this.props.authorableContent.bsipServiceTerm.ntuDefaultQuantity,
      inDialNumberDetailFirstName: this.props.authorableContent.inDialNumberDetailingSection.formFields.userFirstName.placeholder,
      inDialNumberDetailLasttName: this.props.authorableContent.inDialNumberDetailingSection.formFields.userLastName.placeholder,
      pabxVendor: this.props.authorableContent.inDialSipNetworkConnectionDevice.formFields.pabxVendor,
    };
    omnitureTriggerEventAction('formSuccess');
    const siteToBeSubmitted = this.props.sitesData.filter(site => site.siteId === this.state.selectedSiteId);
    const dataForSubmit = prepareISDNSubmitCustomerData(this.state, siteToBeSubmitted, authorableData);
    submitSSMCustomerData(dataForSubmit);
  };

  handleProceedToOrderSummary = () => {
    const newOrderSummaryData =
      updateOrderSummaryAfterServiceTableChanges(this.props.authorableContent.serviceTerm, this.props.sitesData, this.state);
    this.setState({ currentView: SSM_ORDER_SUMMARY_VIEW, orderSummaryData: newOrderSummaryData });
  };

  handleAmendButtonClick = (siteId) => {
    const selectedSiteData = this.props.sitesData.filter(siteData => siteData.siteId === siteId)[0];
    this.updateSiteAddressDropDownSelection(selectedSiteData);
  };

  handleBackToReviewServices = () => {
    this.setState({ currentView: SSM_REVIEW_SERVICES_VIEW });
  };

  handleAddressSearch = (query) => {
    const { addressSearch } = this.state;
    this.setState({ addressSearch: { ...addressSearch, isLoading: true } });
    getAddressSearchResult(query)
      .then((response) => {
        if (response) {
          this.setState({
            addressSearch: {
              ...addressSearch,
              isLoading: false,
              options: response.data,
            },
          });
        }
      });
  };

  handleSuggestedAddressListOnBlur = (event) => {
    const { suggestedAddressList } = this.state.addressSearch;
    this.updateDeliveryAddressDataAfterSuggestedAddressChange(event.target.value, suggestedAddressList);
  };

  handleAddressSelected = (selected) => {
    const { addressSearch } = this.state;
    if (selected.length && selected.length > 0) {
      this.setState({
        addressSearch: {
          ...addressSearch, addressVerificationInProcess: true, selected,
        },
      });
      getAddressDetails(selected[0].addressId)
        .then((response) => {
          if (response.data.length > 1) { // it means that original address typed is invalid, and we need to show the suggested addresses
            const suggestedAddressList = getSuggestedAddressList(response.data);
            this.setState({
              addressSearch:
                {
                  ...addressSearch,
                  suggestedAddressList,
                  showSuggestedAddressList: true,
                  selected,
                  addressVerificationInProcess: false,
                },
              isLoadingAddressDetails: true,
              showUpdateDeliveryAddressSection: true,
            });
          } else {
            const data = response.data[0];
            const fullAddress = `${data.streetNumber} ${data.streetName} ${data.suburb}`;
            this.updateDeliveryAddressDataAfterAddressChange(response.data);
            this.setState({
              addressSearch:
                {
                  ...addressSearch,
                  selectedAddress: fullAddress,
                  selectedAddressId: data.addressId,
                  selected,
                  addressVerificationInProcess: false,
                  showAddressUpdateCompletedMessage: true,
                },
              isLoadingAddressDetails: true,
              showUpdateDeliveryAddressSection: false,
            });
          }
        });
    }
  };

  handleInDialServiceNumberSelectionChange = (selected) => {
    if (selected[0] !== undefined) {
      const selectedValue = selected[0].serviceNumber;
      const selector = `input[value="${selectedValue}"]`;
      const element = document.querySelector(selector);
      const elementId = element.getAttribute('aria-label');
      const newInDialServiceNumberData = this.state.inDialServiceNumberData || {};
      newInDialServiceNumberData[elementId] = selectedValue;
      this.setState({inDialServiceNumberData: newInDialServiceNumberData});
    }
  };

  handleInDialServiceNumberSelectionBlur = (event) => {
    const elementId = event.target.getAttribute('aria-label');
    this.markSiteProcessed(this.state.selectedSiteId);
    const newInDialServiceNumberData = this.state.inDialServiceNumberData || {};
    newInDialServiceNumberData[elementId] = event.target.value;
    this.setState({inDialServiceNumberData: newInDialServiceNumberData});
  };

  updateDeliveryAddressDataAfterAddressChange = (selectedAddressObject) => {
    const { deliveryAddressesData, selectedSiteId } = this.state;
    const newDeliveryAddressData = getUpdatedDeliveryAddressData(selectedAddressObject, deliveryAddressesData, selectedSiteId);
    this.updateDeliveryAddressData(newDeliveryAddressData, false);
  };

  updateDeliveryAddressDataAfterSuggestedAddressChange = (newSelectedAddressId, suggestedAddressList) => {
    const { deliveryAddressesData, selectedSiteId } = this.state;
    const newDeliveryAddressData = getUpdatedDeliveryAddressDataUsingSuggestedAddresses(newSelectedAddressId,
      suggestedAddressList, deliveryAddressesData, selectedSiteId);
    this.updateDeliveryAddressData(newDeliveryAddressData, true);
  };

  updateOrderSummaryData = (orderSummaryData) => {
    this.setState({ orderSummaryData });
  };

  updateSeviceTermDeviceData = (serviceTermDeviceData) => {
    this.setState({ serviceTermDeviceQuantityData: serviceTermDeviceData });
  };

  updateSeviceTermConnectionDateData = (serviceTermConnectionDateData) => {
    this.setState({ serviceTermConnectionDateData });
  };

  updateCustomerBillingAccountNumber = (sitesBillingData) => {
    this.setState({ sitesBillingAccountNumber: sitesBillingData });
  }

  updateConfirmOrderData = (confirmOrderData) => {
    this.setState({ confirmOrderData });
  };

  updateServiceUsageData = (serviceUsageData) => {
    this.setState({ serviceUsageData });
  };

  updateRedirectTypeData = (redirectTypeData) => {
    this.setState({ redirectTypeData });
  };

  updateRedirectNumberData = (redirectNumberData) => {
    this.setState({ redirectNumberData });
  };

  updateNameDisplay = (nameDisplayData) => {
    this.setState({ nameDisplayData });
  };

  updateRedirectNumberErrorData = (redirectNumberFieldErrors) => {
    this.setState({ redirectNumberFieldErrors });
  };

  updateRedirectTypeErrorData = (redirectTypeFieldErrors) => {
    this.setState({ redirectTypeFieldErrors });
  };

  updateServiceUsageErrorData= (serviceUsageTypeFieldErrors) => {
    this.setState({ serviceUsageTypeFieldErrors });
  };

  updateContactSiteDetails = (formFields) => {
    this.setState({ formFields });
  };

  updateSitesBsipCallingPlanSelection = (sitesBsipCallingPlanSelection) => {
    this.setState({ sitesBsipCallingPlanSelection });
  };

  updateSitesBsipServiceTermContractMonths = (sitesBsipContractMonthsData) => {
    this.setState({ sitesBsipContractMonthsData });
  };

  updateShowServiceMessageError = (showServicesErrorMessage) => {
    // using timeout as direct setState is not working for false
    setTimeout(() => {
      this.setState({ showServicesErrorMessage });
      if (this.state.showSiteContactErrorMessage === false && showServicesErrorMessage) {
        scrollElementIntoView('services-error-section');
      }
    }, 100);
  };

  updateShowServiceMessageErrorDisableConfirmButton = (showServicesErrorMessage) => {
    // using timeout as direct setState is not working for false
    setTimeout(() => {
      this.setState({ showServicesErrorMessage, confirmChangesSelected: false });
      if (showServicesErrorMessage) {
        scrollElementIntoView('services-error-section');
      }
    }, 100);
  };


  updateContactSiteErrorMessageData = (contactSiteFieldsHasErrors) => {
    this.setState({ contactSiteFieldsHasErrors });
  };

  prepareConfirmChangesRadioButtonStateOnToggle = (radioButtonClicked) => {
    const newConfirmChangesRadioButtonOptions = this.state.confirmChangesOptions.radioButtons.map((radioButton) => {
      if (radioButton.id === radioButtonClicked.id) {
        return { ...radioButton, checked: radioButtonClicked.checked };
      }
      return { ...radioButton, checked: !radioButtonClicked.checked };
    });
    this.updateConfirmChangesRadioButtonState(newConfirmChangesRadioButtonOptions, radioButtonClicked.checked);
  };

  prepareISDNGoToOptionsRadioButtonStateOnToggle = (radioButtonClicked) => {
    omnitureTriggerEventAction(`go to options selected ${radioButtonClicked.id}`);
    this.markSiteProcessed(this.state.selectedSiteId);
    const newIsdnOptionSelection = this.state.isdnGoToOptions.filter(isdnOption => isdnOption.siteId !== this.state.selectedSiteId);
    newIsdnOptionSelection.push({
      siteId: this.state.selectedSiteId,
      isdnGoTo: radioButtonClicked.id,
    });

    this.setState({ isdnGoToOptions: newIsdnOptionSelection, formSubmitted: false });
  };

  updateIsdnGoToOptionsSelections = (isdnGoToOptions) => {
    this.setState({ isdnGoToOptions });
  };


  updateConfirmChangesRadioButtonState = (confirmChangesRadioButtonOptions, confirmChangesStatus) => {
    this.setState({
      ...this.state,
      confirmChangesOptions: {
        ...this.state.confirmChangesOptions,
        radioButtons: confirmChangesRadioButtonOptions,
      },
      confirmChangesSelected: confirmChangesStatus,
    });
  };

  resetConfirmChangesRadioButtonState = () => {
    const confirmChangesRadioButtonOptions = {
      radioButtons: [
        { id: RADIO_BUTTON_CONFIRM_ID, checked: false },
        { id: RADIO_BUTTON_REVIEW_ID, checked: false },
      ],
    };
    this.setState({
      ...this.state,
      confirmChangesOptions: confirmChangesRadioButtonOptions,
      confirmChangesSelected: false,
      formSubmitted: true,
    });
  }

  handleOnBlurSiteContactDetails = (event) => {
    if (event.target.id === SITE_CONTACT_FIRST_NAME) {
      omnitureTriggerEventAction('firstNameEntered');
    } else if (event.target.id === SITE_CONTACT_LAST_NAME) {
      omnitureTriggerEventAction('lastNameEntered');
    } else if (event.target.id === SITE_CONTACT_EMAIL) {
      omnitureTriggerEventAction('emailEntered');
    } else {
      omnitureTriggerEventAction('phoneNumberEntered');
    }
    this.markSiteProcessed(this.state.selectedSiteId);
    const confirmRadioButton = this.state.confirmChangesOptions.radioButtons.filter(radioButton => radioButton.id === RADIO_BUTTON_CONFIRM_ID)[0];
    if (confirmRadioButton.checked && validateSiteContactFormFieldsOnSubmit(this.state.formFields)) {
      this.setState({ showSiteContactErrorMessage: false });
    } else if (this.state.showSiteContactErrorMessage && validateSiteContactFormFieldsOnSubmit(this.state.formFields)) {
      this.setState({ showSiteContactErrorMessage: false });
    }
    this.contactSiteFormFieldValidationOnBlur(event.target.id, event.target.value);
    const newFormFields = this.state.formFields.map((formField) => {
      if (formField.siteId === this.state.selectedSiteId) {
        return { ...formField, [event.target.id]: event.target.value, isSiteProcessed: true };
      }
      return { ...formField };
    });
    this.setState({ formFields: newFormFields });
  };

  handleOnChangeRedirectNumber = (event) => {
    const { redirectNumberData } = this.state;
    if (validateNumber(event.target.value)) {
      this.setState({ redirectNumberData: { ...redirectNumberData, [event.target.id]: event.target.value } });
    }
  };

  handleOnBlurAdditionalInfo = () => {
    omnitureTriggerEventAction('Additional information added');
    this.markSiteProcessed(this.state.selectedSiteId);
  }

  handleOnChangeNameDisplay = (event) => {
    const { nameDisplayData } = this.state;
    this.setState({ nameDisplayData: { ...nameDisplayData, [event.target.id]: event.target.value } });
  };

  handleOnAccountNumberSelectionOnBlur = (event) => {
    omnitureTriggerEventAction(`Billing account number changed ${event.target.value}`);
    this.markSiteProcessed(this.state.selectedSiteId);
    const newSitesBillingAccountNumber = this.state.sitesBillingAccountNumber || {};
    newSitesBillingAccountNumber[this.state.selectedSiteId] = event.target.value;
    this.setState({ sitesBillingAccountNumber: newSitesBillingAccountNumber });
  }

  handleOnBlurRedirectNumber = (event) => {
    this.markSiteProcessed(this.state.selectedSiteId);
    const { redirectNumberData, redirectNumberFieldErrors } = this.state;
    if (validateNumber(event.target.value)) {
      this.setState({ redirectNumberData: { ...redirectNumberData, [event.target.id]: event.target.value },
        redirectNumberFieldErrors: { ...redirectNumberFieldErrors, [event.target.id]: !validatePhoneNumber(event.target.value) } });
    }
  };

  handleOnChangeSiteContactDetails = (event) => {
    const newFormFields = this.state.formFields.map((formField) => {
      if (formField.siteId === this.state.selectedSiteId) {
        return { ...formField, [event.target.id]: event.target.value, isSiteProcessed: true };
      }
      return { ...formField };
    });
    this.setState({ formFields: newFormFields });
  };

  handleCloseAddressUpdateMessageBox = () => {
    const { addressSearch } = this.state;
    this.setState({
      addressSearch:
        {
          ...addressSearch, showAddressUpdateCompletedMessage: false,
        },
    });
  };


  handleISDNRedirectCancelClick = (radioButtonClicked) => {
    this.markSiteProcessed(this.state.selectedSiteId);
    const isdnRedirectCancelChecks = this.state.isdnRedirectCancelChecks || {};
    const idSpittedData = radioButtonClicked.id.split('-');
    const redirectAllId = `redirectAll-${this.state.selectedSiteId}`;
    const cancelAllId = `cancelAll-${this.state.selectedSiteId}`;
    let newIsdnRedirectCancelChecks = {};
    isdnRedirectCancelChecks[radioButtonClicked.id] = radioButtonClicked.checked;
    if (idSpittedData[0] === 'redirectAll') {
      const redirectSiteServices = this.props.sitesData.filter(siteData => siteData.siteId === this.state.selectedSiteId)[0].siteServices;
      newIsdnRedirectCancelChecks = getIsdnRedirectCancelChecksData(redirectSiteServices, true, this.state.selectedSiteId);
    } else if (idSpittedData[0] === 'cancelAll') {
      const cancelSiteServices = this.props.sitesData.filter(siteData => siteData.siteId === this.state.selectedSiteId)[0].siteServices;
      newIsdnRedirectCancelChecks = getIsdnRedirectCancelChecksData(cancelSiteServices, false, this.state.selectedSiteId);
    } else if (idSpittedData[0] === 'redirect') {
      const cancelId = `cancel-${idSpittedData[1]}-${idSpittedData[2]}`;
      isdnRedirectCancelChecks[cancelId] = false;
      delete isdnRedirectCancelChecks[redirectAllId];
      delete isdnRedirectCancelChecks[cancelAllId];
    } else {
      const redirectId = `redirect-${idSpittedData[1]}-${idSpittedData[2]}`;
      isdnRedirectCancelChecks[redirectId] = false;
      delete isdnRedirectCancelChecks[redirectAllId];
      delete isdnRedirectCancelChecks[cancelAllId];
    }
    this.setState({ isdnRedirectCancelChecks: { ...isdnRedirectCancelChecks, ...newIsdnRedirectCancelChecks } });
  };

  handleOnChangeIsdnRedirectNumber = (event) => {
    const isdnRedirectNumberData = this.state.isdnRedirectNumberData || {};
    if (validateNumber(event.target.value) && event.target.value.length < 11) {
      isdnRedirectNumberData[event.target.id] = event.target.value;
    }
    this.setState({ isdnRedirectNumberData });
  };

  handleOnBlurIsdnRedirectNumber = (event) => {
    this.markSiteProcessed(this.state.selectedSiteId);
    const isdnRedirectNumberFieldError = this.state.isdnRedirectNumberFieldError || {};
    isdnRedirectNumberFieldError[event.target.id] = !validatePhoneNumber(event.target.value);
    this.setState({ isdnRedirectNumberFieldError });
  };

  handleOnBlurIsdnRedirectType = (event) => {
    this.markSiteProcessed(this.state.selectedSiteId);
    const isdnRedirectTypeData = this.state.isdnRedirectTypeData || {};
    const isdnRedirectTypeFieldError = this.state.isdnRedirectTypeFieldError || {};
    isdnRedirectTypeData[event.target.id] = event.target.value;
    isdnRedirectTypeFieldError[event.target.id] = event.target.value.length < 0;
    this.setState({ isdnRedirectTypeData, isdnRedirectTypeFieldError });
  };


  handleDeviceQuantityOnChange = (event) => {
    if (validateNumber(event.target.value) && event.target.value.length < 11) {
      const { serviceTermDeviceQuantityData } = this.state;
      const newServiceTermDeviceData = [...serviceTermDeviceQuantityData.filter(deviceData => deviceData.id !== event.target.id)];
      newServiceTermDeviceData.push({
        id: event.target.id,
        quantity: event.target.value,
        focused: true,
      });

      const { serviceProductsArray } = this.state;
      const newServiceProductsArray = [...serviceProductsArray];
      const itemToUpdate = newServiceProductsArray.find(products => products.deviceType === event.target.id.split('-')[0]).items
        .find(item => item.itemName === event.target.id.split('-')[1]);
      itemToUpdate.quantity = event.target.value;
      itemToUpdate.inputFocused = true;

      this.setState(
        {
          serviceProductsArray: newServiceProductsArray,
          serviceTermDeviceQuantityData: newServiceTermDeviceData,
        });
    }
  };

  handleOnChangeIsdnInDialRedirectNumber = (event) => {
    const isdnInDialRedirectNumberData = this.state.isdnInDialRedirectNumberData || {};
    if (validateNumber(event.target.value) && event.target.value.length < 11) {
      isdnInDialRedirectNumberData[event.target.id] = event.target.value;
    }
    this.setState({ isdnInDialRedirectNumberData });
  };

  handleOnBlurIsdnInDialRedirectNumber = (event) => {
    this.markSiteProcessed(this.state.selectedSiteId);
    const isdnInDialRedirectNumberFieldError = this.state.isdnInDialRedirectNumberFieldError || {};
    isdnInDialRedirectNumberFieldError[event.target.id] = !validatePhoneNumber(event.target.value);

    const selectedSiteData = this.props.sitesData.filter(siteData => siteData.siteId === this.state.selectedSiteId)[0];
    const siteId = this.state.selectedSiteId;

    const redirectCancelIsValid = validateRedirectCancelSelectionForInDialSite(siteId,
      selectedSiteData.inDialServices, this.state.isdnInDialServiceRedirectCancelCheckList,
      this.state.isdnInDialRedirectNumberData,
      this.state.isdnInDialRedirectTypeData);

    this.setState({ isdnInDialRedirectNumberFieldError, showServicesErrorMessage: !redirectCancelIsValid });
  };

  handleOnBlurIsdnInDialRedirectType = (event) => {
    this.markSiteProcessed(this.state.selectedSiteId);
    const isdnInDialRedirectTypeData = this.state.isdnInDialRedirectTypeData || {};
    isdnInDialRedirectTypeData[event.target.id] = event.target.value;
    this.setState({ isdnInDialRedirectTypeData });
  };


  handleDeviceQuantityOnBlur = (event) => {
    this.markSiteProcessed(this.state.selectedSiteId);
    if (validateNumber(event.target.value) && event.target.value.length < 11) {
      const { serviceTermDeviceQuantityData } = this.state;
      const newServiceTermDeviceData = [...serviceTermDeviceQuantityData.filter(deviceData => deviceData.id !== event.target.id)];
      newServiceTermDeviceData.push({
        id: event.target.id,
        quantity: event.target.value,
        focused: false,
      });

      const { serviceProductsArray } = this.state;
      const newServiceProductsArray = [...serviceProductsArray];
      const itemToUpdate = newServiceProductsArray.find(products => products.deviceType === event.target.id.split('-')[0]).items
        .find(item => item.itemName === event.target.id.split('-')[1]);
      itemToUpdate.quantity = event.target.value;
      itemToUpdate.inputFocused = false;

      this.setState(
        {
          serviceProductsArray: newServiceProductsArray,
          serviceTermDeviceQuantityData: newServiceTermDeviceData,
        });
    }
  };

  handleBsipDeviceQuantityOnChange = (event) => {
    if (validateNumber(event.target.value) && event.target.value.length < 11) {
      const sipMobilityId = `featuresPacks-sipMobility-${this.state.selectedSiteId}-quantity`;
      const isEnterpriseTrunkForSiteSelected = this.state.sitesSIPInDialMigrateToEnterpriseTrunk[`${this.state.selectedSiteId}-${MIGRATE_TO_ENTERPRISE_TRUNK}`];
      if (event.target.id === sipMobilityId && isEnterpriseTrunkForSiteSelected === false) {
          const selectedSiteData = this.props.sitesData.find(siteData => siteData.siteId === this.state.selectedSiteId);
          const deviceName = getSipConnectDeviceName(this.state.sitesSipConnectPabxVendor, this.state.sitesSipConnectPabxModel,
            this.state.sitesSipConnectNumberOfTrunks, this.state.selectedSiteId, selectedSiteData.inDial, selectedSiteData.iSDN2);
          const numberOfTrunks = getSipConnectNumberOfTrunks(this.state.sitesSipConnectNumberOfTrunks, this.state.selectedSiteId, 
            selectedSiteData.inDial, selectedSiteData.iSDN2, deviceName);
          if (parseInt(event.target.value, 10) > numberOfTrunks) {
            event.preventDefault();
            return;
          }
      }

      const { serviceTermDeviceQuantityData } = this.state;
      const newServiceTermDeviceData = [...serviceTermDeviceQuantityData.filter(deviceData => deviceData.id !== event.target.id)];
      newServiceTermDeviceData.push({
        id: event.target.id,
        quantity: event.target.value,
        focused: true,
      });

      this.setState(
        {
          serviceTermDeviceQuantityData: newServiceTermDeviceData,
        });
    }
  };

  handleBsipDeviceQuantityOnBlur = (event) => {
    this.markSiteProcessed(this.state.selectedSiteId);
    if (validateNumber(event.target.value) && event.target.value.length < 11) {
      const { serviceTermDeviceQuantityData } = this.state;
      const newServiceTermDeviceData = [...serviceTermDeviceQuantityData.filter(deviceData => deviceData.id !== event.target.id)];
      newServiceTermDeviceData.push({
        id: event.target.id,
        quantity: event.target.value,
        focused: false,
      });

      this.setState(
        {
          serviceTermDeviceQuantityData: newServiceTermDeviceData,
        });
    }
  };

  handleServiceTermConnectionDayChange = (selectedDay) => {
    const newServiceTermConnectionDateData =
      this.state.serviceTermConnectionDateData.filter(connectionData => connectionData.siteId !== this.state.selectedSiteId);
    newServiceTermConnectionDateData.push({
      siteId: this.state.selectedSiteId,
      connectionDate: selectedDay,
      purchaseRentalSelectedOption: this.state.serviceTermSelectedOption,
    });
    this.setState({ serviceTermConnectionDateData: newServiceTermConnectionDateData });
  };

  contactSiteFormFieldValidationOnBlur = (id, value) => {
    const validatedContactSiteValue = validateContactSiteFormFields(id, value);
    const newFormFieldHasErrorData = this.state.contactSiteFieldsHasErrors.map((formField) => {
      if (formField.siteId === this.state.selectedSiteId) {
        return { ...formField, [id]: { invalid: validatedContactSiteValue, touched: true } };
      }
      return { ...formField };
    });
    this.updateContactSiteErrorMessageData(newFormFieldHasErrorData);
  };

  updateDeliveryAddressData = (deliveryAddressesData, showAddressUpdateCompletedMessage) => {
    const { addressSearch } = this.state;
    this.setState({
      addressSearch:
        {
          ...addressSearch, showAddressUpdateCompletedMessage,
        },
      deliveryAddressesData,
      showUpdateDeliveryAddressSection: false,
    });
  };

  callingPlanCheckBoxChanged= (radioButtonClicked) => {
    omnitureTriggerEventAction(`calling plan options selected ${radioButtonClicked.id}`);
    this.markSiteProcessed(this.state.selectedSiteId);
    const selection = radioButtonClicked.id.split('-');
    const sitesBsipCallingPlanSelection = { ...this.state.sitesBsipCallingPlanSelection };
    sitesBsipCallingPlanSelection[selection[0]] = selection[1];
    this.setState({ sitesBsipCallingPlanSelection });
  }

  bsipServiceTermContractTermSelectionChanged = (event) => {
    omnitureTriggerEventAction(`service contract term changed ${event.target.value}`);
    this.markSiteProcessed(this.state.selectedSiteId);
    const sitesBsipContractMonthsData = this.state.sitesBsipContractMonthsData || {};
    sitesBsipContractMonthsData[this.state.selectedSiteId] = event.target.value;
    this.setState({ sitesBsipContractMonthsData });
  }

  sipServiceTermContractTermSelectionChanged = (event) => {
    omnitureTriggerEventAction(`sip connect service term  ${event.target.value}`);
    this.markSiteProcessed(this.state.selectedSiteId);
    const sitesSipContractMonthsData = this.state.sitesSipContractMonthsData || {};
    sitesSipContractMonthsData[this.state.selectedSiteId] = event.target.value;
    this.setState({ sitesSipContractMonthsData });
  }

  setCallbackPhonenumber = (phoneNumber) => {
    let callBackPhoneNumber = this.state.callBackPhoneNumber || phoneNumber;
    this.setState({ callBackPhoneNumber });
  }

  handleCallbackPhoneNumberOnChange = (event) => {
    let callBackPhoneNumber = this.state.callBackPhoneNumber || '';
    if(event.target.value.length < 11 && validateNumber(event.target.value)){
      callBackPhoneNumber = event.target.value;
      this.setState({ callBackPhoneNumber });
    }
  }

  handleCallbackPhoneNumberOnBlur = (event) => {
    let IsCallBackPhoneNumberhasError = this.state.IsCallBackPhoneNumberhasError || false;
    IsCallBackPhoneNumberhasError = !validatePhoneNumber(event.target.value) || event.target.value.length != 10;
    this.setState({ IsCallBackPhoneNumberhasError });
  }

  handleReviewValid = () => {
    const siteAlreadySubmitted =  this.state.sitesConfirmedList.includes(this.state.selectedSiteId);
    if (siteAlreadySubmitted) {
      this.setState({ alreadySubmittedModalIsOpen: true })
    } else {
      omnitureTriggerEventAction('formFinish');
      this.setState({ showUntouchedErrors: false, showServicesErrorMessage: false, confirmSiteModalIsOpen: true });
    }
  }

  getSplitId = (buttonId) => {
    return buttonId.substring(0,buttonId.lastIndexOf("-"));
  }

  getRadioButtonAction = (buttonId) => {
    return buttonId.substring(buttonId.lastIndexOf("-") + 1);
  }

  handleInDialBsipRadioBtnSelection = (radioButtonClicked) => {
    this.markSiteProcessed(this.state.selectedSiteId);
    let isdnInDialBsipServiceMigrateAllCheck = this.state.isdnInDialBsipServiceMigrateAllCheck || false;
    let isdnInDialBsipServiceMigrateCancelCheckList = this.state.isdnInDialBsipServiceMigrateCancelCheckList || {};
    const siteId = this.state.selectedSiteId ? this.state.selectedSiteId : this.props.sitesData[0].siteId;
    const selectedSiteData = this.props.sitesData.filter(siteData => siteData.siteId === siteId)[0];
    if (radioButtonClicked.checked){
      let buttonAction = this.getRadioButtonAction(radioButtonClicked.id);
      if (buttonAction === 'migrate') {
        isdnInDialBsipServiceMigrateCancelCheckList[radioButtonClicked.id] = radioButtonClicked.checked;
        delete isdnInDialBsipServiceMigrateCancelCheckList[`${this.getSplitId(radioButtonClicked.id)}-cancel`];
        isdnInDialBsipServiceMigrateAllCheck = false;
      }else if (buttonAction === 'cancel') {
        isdnInDialBsipServiceMigrateCancelCheckList[radioButtonClicked.id] = radioButtonClicked.checked;
        delete isdnInDialBsipServiceMigrateCancelCheckList[`${this.getSplitId(radioButtonClicked.id)}-migrate`];
        isdnInDialBsipServiceMigrateAllCheck = false;
      }else if (buttonAction === 'migrateAll') {
        selectedSiteData.inDialServices.map(item => {
          isdnInDialBsipServiceMigrateCancelCheckList[`${siteId}-indial-${item.serviceNumber}-migrate`] = true;
          delete isdnInDialBsipServiceMigrateCancelCheckList[`${siteId}-indial-${item.serviceNumber}-cancel`];
          isdnInDialBsipServiceMigrateAllCheck = true;
        });
      }
    }
    const isdnInDialBsipServiceHasError = Object.keys(isdnInDialBsipServiceMigrateCancelCheckList).every(item => item.includes('cancel') && item.includes(this.state.selectedSiteId));
    this.setState({isdnInDialBsipServiceMigrateCancelCheckList, 
                  isdnInDialBsipServiceMigrateAllCheck,
                  isdnInDialBsipServiceHasError });
    
    if (isdnInDialBsipServiceHasError) {
      scrollMatchingElementIntoView('.isdn-in-dial-bsip-service-details');
    }
  }

  handleInDialTiptRadioBtnSelection = (radioButtonClicked) => {
    this.markSiteProcessed(this.state.selectedSiteId);
    let isdnInDialTiptServiceMigrateAllCheck = this.state.isdnInDialTiptServiceMigrateAllCheck || false;
    let isdnInDialTiptServiceMigrateCancelCheckList = this.state.isdnInDialTiptServiceMigrateCancelCheckList || {};
    const siteId = this.state.selectedSiteId ? this.state.selectedSiteId : this.props.sitesData[0].siteId;
    const selectedSiteData = this.props.sitesData.filter(siteData => siteData.siteId === siteId)[0];
    if (radioButtonClicked.checked){
      let buttonAction = this.getRadioButtonAction(radioButtonClicked.id);
      if (buttonAction === 'migrate') {
        isdnInDialTiptServiceMigrateCancelCheckList[radioButtonClicked.id] = radioButtonClicked.checked;
        delete isdnInDialTiptServiceMigrateCancelCheckList[`${this.getSplitId(radioButtonClicked.id)}-cancel`];
        isdnInDialTiptServiceMigrateAllCheck = false;
      }else if (buttonAction === 'cancel') {
        isdnInDialTiptServiceMigrateCancelCheckList[radioButtonClicked.id] = radioButtonClicked.checked;
        delete isdnInDialTiptServiceMigrateCancelCheckList[`${this.getSplitId(radioButtonClicked.id)}-migrate`];
        isdnInDialTiptServiceMigrateAllCheck = false;
      }else if (buttonAction === 'migrateAll') {
        selectedSiteData.inDialServices.map(item => {
          isdnInDialTiptServiceMigrateCancelCheckList[`${siteId}-indial-${item.serviceNumber}-migrate`] = true;
          delete isdnInDialTiptServiceMigrateCancelCheckList[`${siteId}-indial-${item.serviceNumber}-cancel`];
          isdnInDialTiptServiceMigrateAllCheck = true;
        });
      }
    }
    const isdnInDialTiptServiceHasError = Object.keys(isdnInDialTiptServiceMigrateCancelCheckList).every(item => item.includes('cancel') && item.includes(this.state.selectedSiteId));
    this.setState({isdnInDialTiptServiceMigrateCancelCheckList, 
      isdnInDialTiptServiceMigrateAllCheck,
      isdnInDialTiptServiceHasError });
    if (isdnInDialTiptServiceHasError) {
      scrollMatchingElementIntoView('.isdn-in-dial-tipt-service-details');
    }
    
  }

  handleDefaultInDialRadioBtnSelection = () => {
    let isdnInDialBsipServiceMigrateAllCheck = this.state.isdnInDialBsipServiceMigrateAllCheck || false;
    let isdnInDialBsipServiceMigrateCancelCheckList = this.state.isdnInDialBsipServiceMigrateCancelCheckList || {};
    let isdnInDialTiptServiceMigrateAllCheck = this.state.isdnInDialTiptServiceMigrateAllCheck || false;
    let isdnInDialTiptServiceMigrateCancelCheckList = this.state.isdnInDialTiptServiceMigrateCancelCheckList || {};
    const siteId = this.state.selectedSiteId ? this.state.selectedSiteId : this.props.sitesData[0].siteId;
    const selectedSiteData = this.props.sitesData.filter(siteData => siteData.siteId === siteId)[0];
    let isdnInDialBsipServiceMigrateAllDefault = true;
    let isdnInDialTiptServiceMigrateAllDefault = true;
    selectedSiteData.inDialServices.forEach(item => {
      if(isdnInDialBsipServiceMigrateCancelCheckList.hasOwnProperty(`${siteId}-indial-${item.serviceNumber}-migrate`) ||
      isdnInDialBsipServiceMigrateCancelCheckList.hasOwnProperty(`${siteId}-indial-${item.serviceNumber}-cancel`)) {
        isdnInDialBsipServiceMigrateAllDefault = false;
      }
      if(isdnInDialTiptServiceMigrateCancelCheckList.hasOwnProperty(`${siteId}-indial-${item.serviceNumber}-migrate`) ||
      isdnInDialTiptServiceMigrateCancelCheckList.hasOwnProperty(`${siteId}-indial-${item.serviceNumber}-cancel`)) {
        isdnInDialTiptServiceMigrateAllDefault = false;
      }
    });
    if (isdnInDialBsipServiceMigrateAllDefault) {
      selectedSiteData.inDialServices.forEach(item => {
        isdnInDialBsipServiceMigrateCancelCheckList[`${siteId}-indial-${item.serviceNumber}-migrate`] = true;
        delete isdnInDialBsipServiceMigrateCancelCheckList[`${siteId}-indial-${item.serviceNumber}-cancel`];
        isdnInDialBsipServiceMigrateAllCheck = true;
      });
    }
    if (isdnInDialTiptServiceMigrateAllDefault) {
      selectedSiteData.inDialServices.forEach(item => {
        isdnInDialTiptServiceMigrateCancelCheckList[`${siteId}-indial-${item.serviceNumber}-migrate`] = true;
        delete isdnInDialTiptServiceMigrateCancelCheckList[`${siteId}-indial-${item.serviceNumber}-cancel`];
        isdnInDialTiptServiceMigrateAllCheck = true;
      });
    }
    this.setState({isdnInDialBsipServiceMigrateCancelCheckList, 
      isdnInDialBsipServiceMigrateAllCheck,
      isdnInDialTiptServiceMigrateCancelCheckList, 
      isdnInDialTiptServiceMigrateAllCheck });
  }

  handleReviewInvalid = (selector = '.form-error') => {
    setTimeout(() => {
      scrollFirstMatchingElementIntoView(selector);
    }, 200);
  }

  validateReview = (isMigratingToTipt, isMigratingToBsip, isMigratingToSip, isEnterpriseTrunkForSiteSelected) => {
    this.setState({ showUntouchedErrors: true });

    // Migration table has no validated inputs, so can be treated as valid
    let isValid = true;
    let redirectCancelIsValid = true;
    let phoneAnalogueIsValid = true;
    let inDialNumberDetailingTableIsValid = true;    
    let sipConnectValidation = true;

    const selectedSiteErrorData = this.state.contactSiteFieldsHasErrors.find(site => site.siteId === this.state.selectedSiteId);
    const formFieldsData = this.state.formFields.filter(site => site.siteId === this.state.selectedSiteId);

    // Check Site contact validity
    isValid = validateSiteContactFormFieldsOnSubmit(formFieldsData);

    const siteData = this.props.sitesData.filter(siteData => siteData.siteId === this.state.selectedSiteId)[0];

    /** validate sip connect */
    if(isMigratingToSip){
      if(isEnterpriseTrunkForSiteSelected === false){
        const sipConnectServiceTermData = {
          sitesSipContractMonthsData : this.state.sitesSipContractMonthsData, 
          contractTerm : this.props.authorableContent.sipConnectServiceTerm.formFields.contractTerm
        }
        sipConnectValidation = validateSipConnect(this.state.selectedSiteId, this.state.sitesSipConnectPabxVendor, this.state.sitesSipConnectPabxModel,
          this.state.sitesSipConnectNumberOfTrunks, siteData.inDial, siteData.iSDN2, sipConnectServiceTermData);
      }else{
        const dataServicesNumber = (siteData.inDial) ? siteData.inDialServices : siteData.siteServices;
        sipConnectValidation = validateSipConnectEnterpriseTrunk(siteData.siteId, siteData.inDial, this.state.sitesSIPInDialMigrateToEnterpriseTrunkSelection,
          dataServicesNumber);
        
        const enterpriseTrunkValidationTracking = { ...this.state.sitesEnterpriseTrunkValidationTracking};
        enterpriseTrunkValidationTracking[this.state.selectedSiteId] = true;
        this.setState({sitesEnterpriseTrunkValidationTracking : enterpriseTrunkValidationTracking});
      }
      
      this.setState({ formSubmitted: true });
      return isValid && sipConnectValidation ;
    }

    if (siteData.inDial === false) { // multi number validation
      // if redirect is selected
      if (isMigratingToTipt === false && isMigratingToBsip === false) {
        const selectedSiteServices = siteData.siteServices;
        redirectCancelIsValid = validateRedirectCancelSelectionForSite(selectedSiteServices,
          this.state.isdnRedirectCancelChecks, this.state.isdnRedirectNumberData, this.state.isdnRedirectTypeData);
        if (redirectCancelIsValid === false) {
          this.setState({ showServicesErrorMessage: true });
        }
      } else if (isMigratingToBsip) {
        this.setState({ siteReviewed: true });
      } else {
        phoneAnalogueIsValid = !getZeroErrorForMigrationCountForSite(this.state.selectedSiteId, this.state.migrationCounts);
        if (phoneAnalogueIsValid === false) {
          this.setState({ siteReviewed: true, formSubmitted: !phoneAnalogueIsValid});
        }
      }
      return isValid && redirectCancelIsValid && phoneAnalogueIsValid;
    } else { // in dial validation
      let tiptError = false;
      if (isMigratingToTipt) {
        phoneAnalogueIsValid = !getZeroErrorForMigrationCountForSite(this.state.selectedSiteId, this.state.migrationCounts);
        inDialNumberDetailingTableIsValid = validateInDialNumerDetailingTable(this.state.selectedSiteId, this.state.migrationCounts, this.state.inDialServiceNumberData);
        this.setState({formSubmitted: true});

      }
      else if (isMigratingToTipt === false && isMigratingToBsip === false) {
        redirectCancelIsValid = validateRedirectCancelSelectionForInDialSite(this.state.selectedSiteId,
          siteData.inDialServices, this.state.isdnInDialServiceRedirectCancelCheckList,
          this.state.isdnInDialRedirectNumberData,
          this.state.isdnInDialRedirectTypeData);
          this.setState({ showServicesErrorMessage: !redirectCancelIsValid, formSubmitted: true });
      }
      
      const anyErrorPresent = document.querySelector('.form-error');
      return isValid && redirectCancelIsValid && anyErrorPresent === null && phoneAnalogueIsValid && inDialNumberDetailingTableIsValid;
    }
  }
  
  /** handle show more text in in-dial-number-detailing section */
  handleInDialShowAdvanceFeatures = () => {    
    this.setState({inDialDetailingShowMoreText:!this.state.inDialDetailingShowMoreText});
  }

  /** handle indail Redirect  redirect-ALL radion button check and uncheck */
  handleInDialRedirectRadioBtnSelection = (radioButtonClicked) => {
    this.markSiteProcessed(this.state.selectedSiteId);
    let isdnInDialServiceRedirectAllCheck = this.state.isdnInDialServiceRedirectAllCheck || false;
    let isdnInDialRedirectServiceCancelAllCheck = this.state.isdnInDialRedirectServiceCancelAllCheck || false;
    let isdnInDialServiceRedirectCancelCheckList = this.state.isdnInDialServiceRedirectCancelCheckList || {};
    const selectedSiteData = this.props.sitesData.filter(siteData => siteData.siteId === this.state.selectedSiteId)[0];
    const siteId = this.state.selectedSiteId;
    if (radioButtonClicked.checked){
      let buttonAction = this.getRadioButtonAction(radioButtonClicked.id);
      if (buttonAction === 'redirect') {
        isdnInDialServiceRedirectCancelCheckList[radioButtonClicked.id] = radioButtonClicked.checked;
        delete isdnInDialServiceRedirectCancelCheckList[`${this.getSplitId(radioButtonClicked.id)}-cancel`];
        isdnInDialServiceRedirectAllCheck = false;
        isdnInDialRedirectServiceCancelAllCheck = false;
      }else if (buttonAction === 'cancel') {
        isdnInDialServiceRedirectCancelCheckList[radioButtonClicked.id] = radioButtonClicked.checked;
        delete isdnInDialServiceRedirectCancelCheckList[`${this.getSplitId(radioButtonClicked.id)}-redirect`];
        isdnInDialServiceRedirectAllCheck = false;
        isdnInDialRedirectServiceCancelAllCheck = false;
      }else if (buttonAction === 'redirectAll') {
        selectedSiteData.inDialServices.map(item => {
          isdnInDialServiceRedirectCancelCheckList[`${siteId}-indial-${item.serviceNumber}-redirect`] = true;
          delete isdnInDialServiceRedirectCancelCheckList[`${siteId}-indial-${item.serviceNumber}-cancel`];
          isdnInDialServiceRedirectAllCheck = true;
          isdnInDialRedirectServiceCancelAllCheck = false;
        });
      }else if (buttonAction === 'cancelAll') {
        selectedSiteData.inDialServices.map(item => {
          isdnInDialServiceRedirectCancelCheckList[`${siteId}-indial-${item.serviceNumber}-cancel`] = true;
          delete isdnInDialServiceRedirectCancelCheckList[`${siteId}-indial-${item.serviceNumber}-redirect`];
          isdnInDialServiceRedirectAllCheck = false;
          isdnInDialRedirectServiceCancelAllCheck = true;
        });
      }
    }

    const redirectCancelIsValid = validateRedirectCancelSelectionForInDialSite(siteId,
      selectedSiteData.inDialServices, isdnInDialServiceRedirectCancelCheckList,
      this.state.isdnInDialRedirectNumberData,
      this.state.isdnInDialRedirectTypeData);

    this.setState({isdnInDialServiceRedirectCancelCheckList, 
      isdnInDialServiceRedirectAllCheck,
      isdnInDialRedirectServiceCancelAllCheck,
      showServicesErrorMessage: !redirectCancelIsValid });
  }

  /** handle show inclusion list under SIP section */
  handleSipInclusionShowAdvanceFeatures = () => {    
    this.setState({sipInclusionShowList:!this.state.sipInclusionShowList});
  }

  handleSipConnectCallingPlanNumberOfTrunks = (event) => {
    this.markSiteProcessed(this.state.selectedSiteId);
    const sitesSipConnectNumberOfTrunks = { ...this.state.sitesSipConnectNumberOfTrunks };
    sitesSipConnectNumberOfTrunks[event.target.id] = event.target.value;

	  const sipMobilityId = `featuresPacks-sipMobility-${this.state.selectedSiteId}-quantity`;
    const { serviceTermDeviceQuantityData } = this.state;
    const newServiceTermDeviceData = [...serviceTermDeviceQuantityData.filter(deviceData => deviceData.id !== sipMobilityId)];
    newServiceTermDeviceData.push({
      id: sipMobilityId,
      quantity: '0',
      focused: true,
    });

    this.setState({ sitesSipConnectNumberOfTrunks, serviceTermDeviceQuantityData: newServiceTermDeviceData });
  }

  /** reset sip calling number of trunk drop down value */
  resetSipCallingPlanDropDown = () => {
    if(this.state.sitesSipConnectNumberOfTrunks[this.state.selectedSiteId] !== undefined){
      const sitesSipConnectNumberOfTrunks = { ...this.state.sitesSipConnectNumberOfTrunks };
      sitesSipConnectNumberOfTrunks[this.state.selectedSiteId] = SIP_CALLING_PLAN_SELECT_OPTION;
      this.setState({ sitesSipConnectNumberOfTrunks });  
    }    
  }

  handleSipConnectPabxVendorChange = (event) => {
    this.markSiteProcessed(this.state.selectedSiteId);
    const sitesSipConnectPabxVendor = { ...this.state.sitesSipConnectPabxVendor };
    sitesSipConnectPabxVendor[this.state.selectedSiteId] = event.target.value;
    const sitesSipConnectPabxModel = { ...this.state.sitesSipConnectPabxModel };
    delete sitesSipConnectPabxModel[this.state.selectedSiteId];
    this.setState({ sitesSipConnectPabxVendor, sitesSipConnectPabxModel });
    this.resetSipCallingPlanDropDown();
  }

  handleSipConnectPabxModelChange = (event) => {
    this.markSiteProcessed(this.state.selectedSiteId);
    const sitesSipConnectPabxModel = { ...this.state.sitesSipConnectPabxModel };
    sitesSipConnectPabxModel[this.state.selectedSiteId] = event.target.value;
    this.setState({ sitesSipConnectPabxModel });
    this.resetSipCallingPlanDropDown();
  }

  handleMigrateToEnterpriseTrunk = (radioButtonClicked) => {
    this.markSiteProcessed(this.state.selectedSiteId);
    const siteId = this.state.selectedSiteId ? this.state.selectedSiteId : this.props.sitesData[0].siteId;
    let buttonAction = this.getRadioButtonAction(radioButtonClicked.id);
    let migrateToEnterpriseTrunk = this.state.sitesSIPInDialMigrateToEnterpriseTrunk;
    if(buttonAction === MIGRATE_TO_ENTERPRISE_TRUNK){
      migrateToEnterpriseTrunk[`${siteId}-${MIGRATE_TO_ENTERPRISE_TRUNK}`] = true; 
    }else {
      migrateToEnterpriseTrunk[`${siteId}-${MIGRATE_TO_ENTERPRISE_TRUNK}`] = false;
    }
    this.setState({sitesSIPInDialMigrateToEnterpriseTrunk : migrateToEnterpriseTrunk});
  }

  handlEnterpriseTrunkSelection = (optionSelected) => {
    this.markSiteProcessed(this.state.selectedSiteId);
    const SIPInDialMigrateToEnterpriseTrunkSelected = this.state.sitesSIPInDialMigrateToEnterpriseTrunkSelection;
    SIPInDialMigrateToEnterpriseTrunkSelected[optionSelected.target.id] = optionSelected.target.value;
    const newEnterpriseTrunkingRequestCallBackForSites = this.state.enterpriseTrunkingRequestCallBackForSites;
    const isCallBackRequestDone = newEnterpriseTrunkingRequestCallBackForSites[`${this.state.selectedSiteId}`]
    if (optionSelected.target.value === 'REQUEST_CALL_BACK' && isCallBackRequestDone === undefined) {
      newEnterpriseTrunkingRequestCallBackForSites[`${this.state.selectedSiteId}`] = true;
      this.onOpenRequestCallBack();
      this.setState({ 
        sitesSIPInDialMigrateToEnterpriseTrunkSelection : SIPInDialMigrateToEnterpriseTrunkSelected,
        enterpriseTrunkingRequestCallBackForSites: newEnterpriseTrunkingRequestCallBackForSites,
       });
    } else {
      this.setState({ sitesSIPInDialMigrateToEnterpriseTrunkSelection : SIPInDialMigrateToEnterpriseTrunkSelected });
    }
    
  }

  render() {
    if (this.props.dataLoaded && this.props.isdnProduct && this.state.currentView === SSM_REVIEW_SERVICES_VIEW) {
      const { customerAccountNumbers, customerAccountName, customerContactPhone, sitesData, virtualServicesPresent, autoSaveStatus, cwpBanner } = this.props;
      const customerDefaultAccountNumber = customerAccountNumbers[0];
      const
        {
          customNet:
            {
              title: pageTitle, accountNameText, accountNumberText, cwpBannerText,
            },
          changingServices:
            {
              summaryTitle: changingServicesSummaryTitle, summary: changingServicesSummary,
            },
          isdnGoToOptions:
          {
            summaryTitle: isdnGotoSummaryTitle,
            migrateAllToTipt: { summary: migrateAllToTiptSummary, title: migrateAllToTiptTitle },
            redirectAndOrCancel: { summary: redirectAndOrCancelSummary, title: redirectAndOrCancelTitle },
            migrateAllToBsip: { summary: migrateAllToBsipSummary, title: migrateAllToBsipTitle },
            migrateToSipConnect: { summary: migrateAllToSipConnectSummary, title: migrateAllToSipConnectTitle },
          },
          confirmChanges:
            {
              summary: confirmChangesSummary,
              privacyTitle,
              privacySummary,
              migrateAll: { summary: migrateAllSummary, title: migrateAllTitle },
              contactAe: { summary: contactAeSummary, title: contactAeTitle },
              submitButton,
              reviewNextSiteButton,
              bsipSummaryTitle,
              bsipSummary,
              proceedButton,
            },
          confirmation: {
            summaryTitlePre,
            summaryTitlePost,
            summary: siteSubmittedSummary,
            alreadySubmittedTitle,
            alreadySubmittedDescription,
          },
          serviceTerm: serviceTermAuthorableContent,
          bsipServiceTerm,
          sipConnectServiceTerm,
          bsipCallingPlan,
          bsipServiceDetails,
          requestCallBack: {
            requestCallBackModal: {
              title: requestCallbackOfflineTitle,
              text: requestCallbackOfflineText,
              yesText: requestCallbackOfflineYesText,
              formFields: requestCallbackOfflineFormfields,
            },
            thankYouModal: {
              title: callbackThankYouTitle,
              text: callbackThankYouText,
            },
            floatingCtaCallBack: {
              icon: callbackIcon,
              text: callbackText,
            },
            liveChatModal: {
              title: liveChatModalTitle,
              text: liveChatModalText,
              callbackText: callBackButtontext,
              chatNowText: chatNowButtonText,
            },
          },
          inDialNumberDetailingSection,
          inDialSipNetworkConnectionDevice: sipConnectNetworkConnectionDeviceContent,
          inDialSipCallingPlans,
        } = this.props.authorableContent;
      
      const authorableSitesData = { ...this.props.authorableContent.sitesData };

      const {
        deliveryAddressHeadingText,
        deliveryAddressInfoText,
        updateAddressLinkText,
        suggestedAddressListPlaceHolder,
        summaryTitle: whatYouNeedToDoSummaryTitle,
        summary: whatYouNeedToDoSummary,
        addressUpdateCompletedText,
        andText,
        confirmSitesText,
      } = authorableSitesData;

      const contentHeader = {
        heading: pageTitle,
        description: '',
      };
      const sitesAddressList = sitesData.map(site => (
        {
          value: getFullCombinedAddress(site),
          id: site.siteId,
        }
      ));

      const selectedSiteData = sitesData.filter(siteData => siteData.siteId === this.state.selectedSiteId)[0];
      const selectedSiteContactFormFieldData = this.state.formFields.filter(formFieldData => formFieldData.siteId === this.state.selectedSiteId)[0];
      const selectedSiteContactFormErrors = this.state.contactSiteFieldsHasErrors
        .filter(formFieldErrorsData => formFieldErrorsData.siteId === this.state.selectedSiteId)[0];
      const selectedDeliveryAddress = this.state.deliveryAddressesData.length > 0 && this.state.deliveryAddressesData
        .filter(delieveryAddress => delieveryAddress.siteId === this.state.selectedSiteId)[0].fullAddress;
      const numberOfVirtualServices = sitesData && sitesData[sitesData.length - 1].siteServices.length;

      const updatedSiteDetailHeading =  `${authorableSitesData.siteNumberPrefix} ${sitesData.length - this.state.sitesConfirmedList.length} ${authorableSitesData.siteNumberSuffix} ${andText} ${this.state.sitesConfirmedList.length} ${confirmSitesText}`;
      const submittedSitesText = `${this.state.sitesConfirmedList.length}/${sitesData.length} ${serviceTermAuthorableContent.submittedText}`;

      const isdnOptionSelectedSite = this.state.isdnGoToOptions.filter(isdnOption => isdnOption.siteId === this.state.selectedSiteId)[0];

      const migrateAllToTiptRadioButtonChecked = isdnOptionSelectedSite && isdnOptionSelectedSite.isdnGoTo === ISDN_GOTOOPTION_MIGRATE_ALL_TIPT;
      const migrateAllToBsipRadioButtonChecked = isdnOptionSelectedSite && isdnOptionSelectedSite.isdnGoTo === ISDN_GOTOOPTION_MIGRATE_ALL_BSIP;
      const redirectOrCancelRadioButtonChecked = isdnOptionSelectedSite && isdnOptionSelectedSite.isdnGoTo === ISDN_GOTOOPTION_REDIRECT_OR_CANCEL;
      const migrateAllToSipConnectRadioButtonChecked = isdnOptionSelectedSite && isdnOptionSelectedSite.isdnGoTo === ISDN_GOTOOPTION_MIGRATE_ALL_SIP_CONNECT;

      const isdnGotoOptionsRadioButtons = [{
        radioButtonId: ISDN_GOTOOPTION_MIGRATE_ALL_BSIP,
        radioButtonLabel: migrateAllToBsipTitle,
        radioButtonDesc: stripStartingAndEndingPTags(migrateAllToBsipSummary),
        radioButtonChecked: migrateAllToBsipRadioButtonChecked,
        onRadioButtonCallBackActionWithToggle: this.onISDNRadioButtonCallBackActionWithToggle,
      },
      {
        radioButtonId: ISDN_GOTOOPTION_MIGRATE_ALL_TIPT,
        radioButtonLabel: migrateAllToTiptTitle,
        radioButtonDesc: stripStartingAndEndingPTags(migrateAllToTiptSummary),
        radioButtonChecked: migrateAllToTiptRadioButtonChecked,
        onRadioButtonCallBackActionWithToggle: this.onISDNRadioButtonCallBackActionWithToggle,
      },
      {
        radioButtonId: ISDN_GOTOOPTION_MIGRATE_ALL_SIP_CONNECT,
        radioButtonLabel: migrateAllToSipConnectTitle,
        radioButtonDesc: stripStartingAndEndingPTags(migrateAllToSipConnectSummary),
        radioButtonChecked: migrateAllToSipConnectRadioButtonChecked,
        onRadioButtonCallBackActionWithToggle: this.onISDNRadioButtonCallBackActionWithToggle,
      },
      {
        radioButtonId: ISDN_GOTOOPTION_REDIRECT_OR_CANCEL,
        radioButtonLabel: redirectAndOrCancelTitle,
        radioButtonDesc: stripStartingAndEndingPTags(redirectAndOrCancelSummary),
        radioButtonChecked: redirectOrCancelRadioButtonChecked,
        onRadioButtonCallBackActionWithToggle: this.onISDNRadioButtonCallBackActionWithToggle,
      }];

      const confirmChangesRadioButtons = [{
        radioButtonId: RADIO_BUTTON_CONFIRM_ID,
        radioButtonLabel: migrateAllTitle,
        radioButtonDesc: stripStartingAndEndingPTags(migrateAllSummary),
        radioButtonChecked: this.state.confirmChangesOptions.radioButtons.filter(option => option.id === RADIO_BUTTON_CONFIRM_ID)[0].checked,
        onRadioButtonCallBackActionWithToggle: this.onRadioButtonCallBackActionWithToggle,
      }];

      const confirmSiteModalAuthorableContent = {
        confirmSummaryText: stripStartingAndEndingPTags(confirmChangesSummary),
        bsipSummaryTitle,
        bsipSummaryText: stripStartingAndEndingPTags(bsipSummary),
        privacyTitle,
        privacySummary,
        confirmCheckBoxId: RADIO_BUTTON_CONFIRM_ID,
        confirmCheckboxLabel: migrateAllTitle,
        confirmCheckboxDesc: stripStartingAndEndingPTags(migrateAllSummary),
        submitButtonText: submitButton,
        proceeedNextSiteText: proceedButton,
        summaryTitlePre,
        summaryTitlePost,
        siteSubmittedSummary,
      };

      const requestCallBackOfflineAuthorableContent = {
        requestCallbackOfflineTitle,
        requestCallbackOfflineText,
        requestCallbackOfflineYesText,
        requestCallbackOfflineFormfields,
        callbackThankYouTitle,
        callbackThankYouText,
      };

      const requestCallBackLiveChatOnlineAuthorableContent = {
        liveChatModalTitle,
        liveChatModalText,
        callBackButtontext,
        chatNowButtonText,
        callbackThankYouTitle,
        callbackThankYouText,
      };

      const alreadySubmittedAuthorableContent = {
        alreadySubmittedTitle,
        alreadySubmittedDescription,
      };

      const callbackCta = [
        {
          icon: callbackIcon,
          text: callbackText,
          onCtaClick: () => {
            this.onOpenRequestCallBack();
          }
        }
      ];

      const siteStatusAuthorableContent = {
        notStartedText: serviceTermAuthorableContent.orderReviewStatusText,
        partiallySavedText: serviceTermAuthorableContent.partiallySavedText,
        submittedText:serviceTermAuthorableContent.readyForSubmissionText,
      };

      const isMigrationCountZero=getZeroErrorForMigrationCountForSite(this.state.selectedSiteId, this.state.migrationCounts);

      const inDialNumberDetailingData = selectedSiteData && selectedSiteData.inDialServices ? selectedSiteData.inDialServices : [];
      const authorableIsdnInDialServiceDetailsData = { ...this.props.authorableContent.inDialIsdnServiceDetails };
      
      const bsipNumberOfTrunks = selectedSiteData && selectedSiteData.inDial ? getNumberOfTrunksInDial(selectedSiteData.inDialServices,
        this.state.isdnInDialBsipServiceMigrateCancelCheckList, this.state.selectedSiteId) : getNumberOfTrunks(selectedSiteData !==undefined ? selectedSiteData.siteServices : []);
      
      const bsipNumberOfBlocks = selectedSiteData && selectedSiteData.inDial ? getInDialNumberBlocksCount(selectedSiteData.inDialServices,
        this.state.isdnInDialBsipServiceMigrateCancelCheckList, this.state.selectedSiteId) : 0;
      
      const sipConnectDevice = selectedSiteData && getSipConnectdevice(this.state.sitesSipConnectPabxVendor, this.state.sitesSipConnectPabxModel,
        this.state.sitesSipConnectNumberOfTrunks, this.state.selectedSiteId, selectedSiteData.inDial, selectedSiteData.iSDN2);
      
      const sipConnectTrunks = this.state.sitesSipConnectNumberOfTrunks[this.state.selectedSiteId] && this.state.sitesSipConnectNumberOfTrunks[this.state.selectedSiteId] !== SIP_CONNECT_NETWORK_DEVICE_SELECT_OPTION
       ? this.state.sitesSipConnectNumberOfTrunks[this.state.selectedSiteId] : 0;

      const isEnterpriseTrunkForSiteSelected = this.state.sitesSIPInDialMigrateToEnterpriseTrunk[`${this.state.selectedSiteId}-${MIGRATE_TO_ENTERPRISE_TRUNK}`];

      return (
        <AppWrapper>
          <div className="ssm-homepage root-container container">
            <ViewHeader content={contentHeader} />
            <CustomerAttributes
              accountNumberLabelText={accountNumberText}
              accountNumberValue={customerDefaultAccountNumber}
              accountNameLabelText={accountNameText}
              accountNameValue={customerAccountName}
            />
            <SummaryDetails summaryTitle={changingServicesSummaryTitle} summaryText={stripStartingAndEndingPTags(changingServicesSummary)} />
            {cwpBanner &&
            <div className="row">
              <div className="col-12 pl-sm-0">
                {renderHTML(cwpBannerText)}
              </div>
            </div>
            }
            {this.state.formFields.length > 0 &&
              <ShowUnTouchedProvider value={this.state.showUntouchedErrors || this.state.showSiteContactErrorMessage}>
                <SiteDetails
                  siteDetailHeading={updatedSiteDetailHeading}
                  siteAddressList={sitesAddressList}
                  siteListSelectedValue={this.state.siteAddressSelected}
                  handleSiteAddressListOnBlur={this.onSiteAddressListBlur}
                  authorableSitesData={authorableSitesData}
                  siteContactFormFieldsState={selectedSiteContactFormFieldData}
                  selectedSiteContactFormErrors={selectedSiteContactFormErrors}
                  handleOnBlur={this.handleOnBlurSiteContactDetails}
                  handleOnChange={this.handleOnChangeSiteContactDetails}
                  showSiteContactErrorMessage={this.state.showSiteContactErrorMessage}
                  siteStatusAuthorableContent={siteStatusAuthorableContent}
                  siteStatusData={this.state.siteStatusData}
                  siteId={this.state.selectedSiteId}
                />
              </ShowUnTouchedProvider>
            }
            {selectedSiteData && !selectedSiteData.virtualSite &&
              <DeliveryAddress
                deliveryAddressHeadingText={deliveryAddressHeadingText}
                deliveryAddressInfoText={deliveryAddressInfoText}
                deliveryAddressValue={selectedDeliveryAddress}
                addressSearch={this.state.addressSearch}
                handleAddressSearch={this.handleAddressSearch}
                handleAddressSelected={this.handleAddressSelected}
                handleClearSearch={this.handleClearSearch}
                handleSuggestedAddressListOnBlur={this.handleSuggestedAddressListOnBlur}
                updateAddressLinkText={updateAddressLinkText}
                handleUpdateDeliveryAddress={this.handleUpdateDeliveryAddress}
                showUpdateDeliveryAddressSection={this.state.showUpdateDeliveryAddressSection}
                suggestedAddressListPlaceHolder={suggestedAddressListPlaceHolder}
                addressUpdateCompletedText={addressUpdateCompletedText}
                handleCloseAddressUpdateMessageBox={this.handleCloseAddressUpdateMessageBox}
              />
            }
            <div id="isdn-goto-options-section" className="isdn-goto-options-section">
              <SummaryDetails summaryTitle={isdnGotoSummaryTitle} summaryText="" />
              <SelectionOption
                iconType="radioButton"
                radioButtonOptions={isdnGotoOptionsRadioButtons}
              />
            </div>
            {selectedSiteData && selectedSiteData.inDial && migrateAllToBsipRadioButtonChecked &&
            <React.Fragment>
              <IsdnInDialBsipServiceDetalis
                authorableContent={authorableIsdnInDialServiceDetailsData}
                inDialServicesDetailsSitedata={selectedSiteData.inDialServices}
                siteId={this.state.selectedSiteId}
                isdnInDialServiceMigrateCancelCheckList={this.state.isdnInDialBsipServiceMigrateCancelCheckList}
                isdnInDialServiceMigrateAllCheck={this.state.isdnInDialBsipServiceMigrateAllCheck}
                handleInDialRadioBtnSelection = {this.handleInDialBsipRadioBtnSelection}
                handleDefaultInDialRadioBtnSelection = {this.handleDefaultInDialRadioBtnSelection}
                isdnInDialBsipServiceHasError={this.state.isdnInDialBsipServiceHasError} 
              />
            </React.Fragment>
            }
            {selectedSiteData && selectedSiteData.inDial && migrateAllToTiptRadioButtonChecked &&
            <React.Fragment>
              <IsdnInDialTiptServiceDetalis
                authorableContent={authorableIsdnInDialServiceDetailsData}
                inDialServicesDetailsSitedata={selectedSiteData.inDialServices}
                siteId={this.state.selectedSiteId}
                isdnInDialServiceMigrateCancelCheckList={this.state.isdnInDialTiptServiceMigrateCancelCheckList}
                isdnInDialServiceMigrateAllCheck={this.state.isdnInDialTiptServiceMigrateAllCheck}
                handleInDialRadioBtnSelection = {this.handleInDialTiptRadioBtnSelection}
                handleDefaultInDialRadioBtnSelection = {this.handleDefaultInDialRadioBtnSelection}
                isdnInDialTiptServiceHasError={this.state.isdnInDialTiptServiceHasError} 
              />
            </React.Fragment>
            }
            {selectedSiteData && selectedSiteData.inDial && migrateAllToSipConnectRadioButtonChecked &&
            <React.Fragment>
              <IsdnInDialSipConnectServiceDetalis
                siteId={this.state.selectedSiteId}
                authorableContent={authorableIsdnInDialServiceDetailsData}
                inDialServicesDetailsSitedata={selectedSiteData.inDialServices}
                sipConnectServiceTermAuthorableContent={sipConnectServiceTerm}
                migrateToEnterpriseTrunk={this.state.sitesSIPInDialMigrateToEnterpriseTrunk}
                migrateToEnterpriseTrunkSelection ={this.state.sitesSIPInDialMigrateToEnterpriseTrunkSelection}
                enterpriseTrunking={selectedSiteData.enterpriseTrunking}
                enterpriseTrunkingNumbers={selectedSiteData.enterpriseTrunkingNumbers}
                handleMigrateToEnterpriseTrunk={this.handleMigrateToEnterpriseTrunk}
                handlEnterpriseTrunkSelection={this.handlEnterpriseTrunkSelection}
                enterpriseTrunkingNumbersOption={this.state.sitesEnterpriseTrunkOptions[this.state.selectedSiteId]}
                enterpriseTrunkValidationTracking={this.state.sitesEnterpriseTrunkValidationTracking[this.state.selectedSiteId]}
                formSubmitted={this.state.formSubmitted}
              />
            </React.Fragment>
            }
            {selectedSiteData && selectedSiteData.inDial && redirectOrCancelRadioButtonChecked &&
            <React.Fragment>
              <IsdnInDialRedirectServiceDetails
                authorableContent={authorableIsdnInDialServiceDetailsData}
                inDialServicesDetailsSitedata={selectedSiteData.inDialServices}
                siteId={this.state.selectedSiteId}
                isdnInDialServiceRedirectCancelCheckList={this.state.isdnInDialServiceRedirectCancelCheckList}
                isdnInDialServiceRedirectAllCheck={this.state.isdnInDialServiceRedirectAllCheck}
                handleInDialRadioBtnSelection = {this.handleInDialRedirectRadioBtnSelection}
                isdnInDialServiceCancelAllCheck = {this.state.isdnInDialRedirectServiceCancelAllCheck}
                isdnInDialRedirectDropDownContent={authorableSitesData.formFields.redirectType}
                isdnInDialRedirectNumberTextFieldContent={authorableSitesData.formFields.redirectNumber}
                isdnInDialRedirectTypeData={this.state.isdnInDialRedirectTypeData}
                isdnInDialRedirectNumberData={this.state.isdnInDialRedirectNumberData}
                onIsdnRedirectTypeSelectionBlur={this.handleOnBlurIsdnInDialRedirectType}
                handleOnChangeRedirectNumber={this.handleOnChangeIsdnInDialRedirectNumber}
                handleOnBlurRedirectNumber={this.handleOnBlurIsdnInDialRedirectNumber}
                isdnInDialRedirectNumberFieldError={this.state.isdnInDialRedirectNumberFieldError}
                showInDialServicesErrorMessage={this.state.formSubmitted && this.state.showServicesErrorMessage}
                servicesErrorMessageText={authorableSitesData.servicesErrorMessageText}
              />
            </React.Fragment>
            }
            {selectedSiteData && migrateAllToTiptRadioButtonChecked &&
            <React.Fragment>
              <IsdnServiceDetails
                authorableContent={{
                  serviceDetailsHeadingText: authorableSitesData.serviceDetailsHeadingText,
                  isdnServiceDetails: this.props.authorableContent.isdnServiceDetails,
                  phoneAndDevicesHeading: whatYouNeedToDoSummaryTitle,
                  phoneAndDevicesDescription: stripStartingAndEndingPTags(whatYouNeedToDoSummary),
                  tableHeadings: {
                    confirmOrder: authorableSitesData.confirmOrderText,
                    currentServiceDetails: authorableSitesData.currentServiceDetailsText,
                  },
                }}
                siteServices={selectedSiteData.siteServices}
                handlePhoneCountChange={this.handlePhoneCountChange}
                handlePhoneCountBlur={this.handlePhoneCountBlur}
                migrationAdvertiseChecks={this.state.migrationAdvertiseChecks}
                onMigrationCheckBoxChange={this.handleMigrationCheckboxChange}
                siteId={this.state.selectedSiteId}
                migrationCounts={this.state.migrationCounts}
                migrationCountErrors={this.state.migrationCountErrors}
                formSubmitted={this.state.formSubmitted}
                siteReviewed={this.state.siteReviewed}
                inDial={selectedSiteData.inDial}
              />
            </React.Fragment>
            }
            {selectedSiteData && migrateAllToTiptRadioButtonChecked && selectedSiteData.inDial &&
              <InDialNumberDetailing 
                inDialNumberSection={this.props.authorableContent.inDialNumberDetailingSection}
                inDialDetailingShowMoreText={this.state.inDialDetailingShowMoreText} 
                handleInDialShowAdvanceFeatures={this.handleInDialShowAdvanceFeatures} 
              />
            }
            {selectedSiteData && redirectOrCancelRadioButtonChecked &&
            <ISDNRedirectServiceDetails
              authorableContent={{
                authorableSiteData: authorableSitesData,
                isdnServiceDetails: this.props.authorableContent.isdnServiceDetails,
                serviceTermAuthorableContent,
              }}
              siteServices={selectedSiteData.siteServices}
              onRedirectCancelClick={this.handleISDNRedirectCancelClick}
              isdnRedirectCancelChecks={this.state.isdnRedirectCancelChecks}
              siteId={selectedSiteData.siteId}
              handleOnChangeRedirectNumber={this.handleOnChangeIsdnRedirectNumber}
              isdnRedirectNumberData={this.state.isdnRedirectNumberData}
              isdnRedirectTypeData={this.state.isdnRedirectTypeData}
              handleOnBlurRedirectType={this.handleOnBlurIsdnRedirectType}
              handleOnBlurRedirectNumber={this.handleOnBlurIsdnRedirectNumber}
              isdnRedirectTypeFieldError={this.state.isdnRedirectTypeFieldError}
              isdnRedirectNumberFieldError={this.state.isdnRedirectNumberFieldError}
              showServicesErrorMessage={this.state.showServicesErrorMessage}
              inDial={selectedSiteData.inDial}
            />
            }
            { selectedSiteData && migrateAllToTiptRadioButtonChecked && selectedSiteData.inDial &&
              <InDialNumberDetailTable
                authorableContent={inDialNumberDetailingSection}
                isMigrationCountZero={isMigrationCountZero}
                inDialNumberDetailingData={inDialNumberDetailingData}
                migrationCounts={this.state.migrationCounts}
                siteId={selectedSiteData.siteId}
                handleOnSelectionChange={this.handleInDialServiceNumberSelectionChange}
                handleOnSelectionBlur={this.handleInDialServiceNumberSelectionBlur}
                handleUserNameOnChange={this.handleInDialUserNameOnChange}
                handleUserNameOnBlur={this.handleInDialUserNameOnBlur}
                handleUserTypeOnChange={this.handleInDialUserTypeOnChange}
                userTypeData={this.state.inDialUserTypeData}
                userNamesData={this.state.inDialUserNamesData}
                serviceNumberData={this.state.inDialServiceNumberData}
                isdnInDialTiptServiceMigrateCancelCheckList={this.state.isdnInDialTiptServiceMigrateCancelCheckList}
                tableError={this.state.formSubmitted && !validateInDialNumerDetailingTable(selectedSiteData.siteId, this.state.migrationCounts, this.state.inDialServiceNumberData)}
              />
            }
            { selectedSiteData && migrateAllToTiptRadioButtonChecked &&
            <ServiceTerm
              authorableContent={serviceTermAuthorableContent}
              products={this.state.serviceProductsArray}
              serviceTermSelectedOption={this.state.serviceTermSelectedOption}
              onServiceTermRadioButtonsToggle={this.onServiceTermRadioButtonsClicked}
              deviceQuantityData={this.state.serviceTermDeviceQuantityData}
              siteId={selectedSiteData.siteId}
              deviceQuantityOnChange={this.handleDeviceQuantityOnChange}
              deviceQuantityOnBlur={this.handleDeviceQuantityOnBlur}
              additionalInfoOnChange={this.handleOnChangeSiteContactDetails}
              additionalInfoOnBlur={this.handleOnBlurAdditionalInfo}
              formFieldsState={selectedSiteContactFormFieldData}
              connectionDayChange={this.handleServiceTermConnectionDayChange}
              connectionDateData={this.state.serviceTermConnectionDateData}
              customerBillingAccountNumber={this.state.sitesBillingAccountNumber[this.state.selectedSiteId]}
              customerAccountNumbers={customerAccountNumbers}
              onAccountNumberSelectionOnBlur={this.handleOnAccountNumberSelectionOnBlur}
              migrationCount={this.state.migrationCounts}
              serviceTermConnectionDateData={this.state.serviceTermConnectionDateData}
              inDialUserTypeData={this.state.inDialUserTypeData}
            />
            }
            {selectedSiteData && migrateAllToBsipRadioButtonChecked && selectedSiteData.inDial === false &&
              <BSIPServiceDetails
                authorableContent={bsipServiceDetails}
                siteServices={selectedSiteData.siteServices}
              />
            }
            {selectedSiteData && migrateAllToSipConnectRadioButtonChecked && selectedSiteData.inDial === false &&
              <SIPConnectServiceDetails
                siteId={this.state.selectedSiteId}
                authorableContent={bsipServiceDetails}
                sipConnectServiceTermAuthorableContent={sipConnectServiceTerm}
                siteServices={selectedSiteData.siteServices}
                enterpriseTrunking={selectedSiteData.enterpriseTrunking}
                enterpriseTrunkingNumbers={selectedSiteData.enterpriseTrunkingNumbers}
                migrateToEnterpriseTrunk={this.state.sitesSIPInDialMigrateToEnterpriseTrunk}
                migrateToEnterpriseTrunkSelection ={this.state.sitesSIPInDialMigrateToEnterpriseTrunkSelection}
                handleMigrateToEnterpriseTrunk={this.handleMigrateToEnterpriseTrunk}
                handlEnterpriseTrunkSelection={this.handlEnterpriseTrunkSelection}
                enterpriseTrunkingNumbersOption={this.state.sitesEnterpriseTrunkOptions[this.state.selectedSiteId]}
                enterpriseTrunkValidationTracking={this.state.sitesEnterpriseTrunkValidationTracking[this.state.selectedSiteId]}
                formSubmitted={this.state.formSubmitted}
              />
            }
            {selectedSiteData && migrateAllToSipConnectRadioButtonChecked && !isEnterpriseTrunkForSiteSelected &&
              <SIPConnectNetworkConnectionDevice
                authorableContent={sipConnectNetworkConnectionDeviceContent}
                sitesSipConnectPabxVendor={this.state.sitesSipConnectPabxVendor}
                handleSipConnectPabxVendorChange={this.handleSipConnectPabxVendorChange}
                siteId={this.state.selectedSiteId}
                sitesSipConnectPabxModel={this.state.sitesSipConnectPabxModel}
                handleSipConnectPabxModelChange={this.handleSipConnectPabxModelChange}
                formSubmitted={this.state.formSubmitted}
              />
            }
            {selectedSiteData && migrateAllToSipConnectRadioButtonChecked && !isEnterpriseTrunkForSiteSelected &&
            <SipCallingPlan
              authorableContent={inDialSipCallingPlans}
              deviceNotSuitableText425={sipConnectNetworkConnectionDeviceContent.deviceNotSuitableText425}
              deviceNotSuitableText270={sipConnectNetworkConnectionDeviceContent.deviceNotSuitableText270}
              deviceNotSuitableText700={sipConnectNetworkConnectionDeviceContent.deviceNotSuitableText700}
              deviceNotRequired={sipConnectNetworkConnectionDeviceContent.deviceNotRequired}
              siteId={this.state.selectedSiteId}
              handleSipInclusionShowAdvanceFeatures={this.handleSipInclusionShowAdvanceFeatures}
              sipInclusionShowList={this.state.sipInclusionShowList}
              handleSipConnectCallingPlanNumberOfTrunks={this.handleSipConnectCallingPlanNumberOfTrunks}
              sitesSipConnectNumberOfTrunks={this.state.sitesSipConnectNumberOfTrunks}
              sitesSipConnectPabxVendor={this.state.sitesSipConnectPabxVendor}
              sitesSipConnectPabxModel={this.state.sitesSipConnectPabxModel}
              inDial={selectedSiteData.inDial}
              ISDN2={selectedSiteData.iSDN2}
              formSubmitted={this.state.formSubmitted}
            />
            }
            {selectedSiteData && migrateAllToSipConnectRadioButtonChecked &&
            <SipConnectServiceTerm
              authorableContent={sipConnectServiceTerm}
              sitesSipContractMonthsData={this.state.sitesSipContractMonthsData}
              sipConnectCallingPlanauthorableContent={inDialSipCallingPlans}
              siteId={this.state.selectedSiteId}
              serviceTermAuthorableContent={serviceTermAuthorableContent}
              sipServiceTermContractTermSelectionChanged={this.sipServiceTermContractTermSelectionChanged}
              products={this.state.sipConnectServiceProductsArray}
              deviceQuantityData={this.state.serviceTermDeviceQuantityData}
              deviceQuantityOnChange={this.handleBsipDeviceQuantityOnChange}
              deviceQuantityOnBlur={this.handleBsipDeviceQuantityOnBlur}
              numberOfTrunks={sipConnectTrunks}
              numberOfPhoneNumbers={getNumberOfTelephoneNumbers(selectedSiteData.siteServices)}
              additionalInfoOnChange={this.handleOnChangeSiteContactDetails}
              additionalInfoOnBlur={this.handleOnBlurAdditionalInfo}
              formFieldsState={selectedSiteContactFormFieldData}
              customerBillingAccountNumber={this.state.sitesBillingAccountNumber[this.state.selectedSiteId]}
              customerAccountNumbers={customerAccountNumbers}
              onAccountNumberSelectionOnBlur={this.handleOnAccountNumberSelectionOnBlur}
              inDial={selectedSiteData.inDial}
              ISDN2={selectedSiteData.iSDN2}
              sipConnectDevice={sipConnectDevice}
              formSubmitted={this.state.formSubmitted}
              isEnterpriseTrunkForSiteSelected={isEnterpriseTrunkForSiteSelected}
            />
            }
            {selectedSiteData && migrateAllToBsipRadioButtonChecked &&
            <BsipCallingPlan
              authorableContent={bsipCallingPlan}
              siteId={this.state.selectedSiteId}
              sitesBsipCallingPlanSelection={this.state.sitesBsipCallingPlanSelection}
              callingPlanCheckBoxChanged={this.callingPlanCheckBoxChanged}
              numberOfTrunks={bsipNumberOfTrunks}
            />
            }
            {selectedSiteData && migrateAllToBsipRadioButtonChecked &&
            <BsipServiceTerm
              authorableContent={bsipServiceTerm}
              bsipCallingPlanauthorableContent={bsipCallingPlan}
              serviceTermAuthorableContent={serviceTermAuthorableContent}
              sitesBsipContractMonthsData={this.state.sitesBsipContractMonthsData}
              siteId={this.state.selectedSiteId}
              bsipServiceTermContractTermSelectionChanged={this.bsipServiceTermContractTermSelectionChanged}
              products={this.state.bsipServiceProductsArray}
              deviceQuantityData={this.state.serviceTermDeviceQuantityData}
              deviceQuantityOnChange={this.handleBsipDeviceQuantityOnChange}
              deviceQuantityOnBlur={this.handleBsipDeviceQuantityOnBlur}
              sitesBsipCallingPlanSelection={this.state.sitesBsipCallingPlanSelection}
              numberOfTrunks={bsipNumberOfTrunks}
              numberOfPhoneNumbers={getNumberOfTelephoneNumbers(selectedSiteData.siteServices)}
              additionalInfoOnChange={this.handleOnChangeSiteContactDetails}
              additionalInfoOnBlur={this.handleOnBlurAdditionalInfo}
              formFieldsState={selectedSiteContactFormFieldData}
              customerBillingAccountNumber={this.state.sitesBillingAccountNumber[this.state.selectedSiteId]}
              customerAccountNumbers={customerAccountNumbers}
              onAccountNumberSelectionOnBlur={this.handleOnAccountNumberSelectionOnBlur}
              inDial={selectedSiteData.inDial}
              numberRangesCount={bsipNumberOfBlocks}
            />
            }
            <ReviewNextSite
              buttonText={reviewNextSiteButton}
              validate={() => this.validateReview(migrateAllToTiptRadioButtonChecked, migrateAllToBsipRadioButtonChecked, migrateAllToSipConnectRadioButtonChecked, isEnterpriseTrunkForSiteSelected)}
              handleValid={this.handleReviewValid}
              handleInvalid={this.handleReviewInvalid}
              reviewDisabled={false}
            />
            <div className="row">
              <div className="col-12">
                <div className="float-right">{submittedSitesText}</div>
              </div>
            </div>
            <ConfirmSiteModal
              modalIsOpen={this.state.confirmSiteModalIsOpen}
              onCloseDialogBox={this.onCloseConfirmSiteModal}
              authorableContent={confirmSiteModalAuthorableContent}
              siteAddress={this.state.siteAddressSelected}
              showAddtionalBsipSection={migrateAllToBsipRadioButtonChecked}
              confirmChangesRadioButtons={confirmChangesRadioButtons}
              confirmSiteCheckBoxChecked={this.state.confirmSiteCheckBoxChecked}
              onConfirmSiteCheckBoxChanged={this.onConfirmSiteCheckBoxChanged}
              handleSubmit={this.handleSubmit}
              referenceNumber={this.props.referenceNumber}
              formSubmitted={this.state.siteFormSubmitted}
              handleProceedNextSite={this.proceedToNextSite}
              formSubmissionInProcess={this.state.formSubmissionInProcess}
            />
            <FloatingCta ctas={callbackCta} />
            <RequestCallBackModalOffline
                customerContactPhone={this.state.callBackPhoneNumber}
                modalIsOpen={this.state.callBackRequestLiveChatOfflineModalIsOpen}
                onCloseDialogBox={this.onCloseRequestCallBackOffline}
                onRequestCallback={this.onRequestCallBackCompleted}
                authorableContent={requestCallBackOfflineAuthorableContent}
                callBackRequestCompleted={this.state.callBackRequestCompleted}
                IsCallBackPhoneNumberhasError={this.state.IsCallBackPhoneNumberhasError}
                onBlur={this.handleCallbackPhoneNumberOnBlur}
                onChange={this.handleCallbackPhoneNumberOnChange}
            />
            <RequestCallBackModalOnline
              modalIsOpen={this.state.callBackRequestLiveChatOnlineModalIsOpen}
              onCloseDialogBox={this.onCloseRequestCallBackOffline}
              onRequestCallback={this.onOnlineRequestCallBack}
              onStartLiveChat={this.onStartLiveChat}
              authorableContent={requestCallBackLiveChatOnlineAuthorableContent}
              callBackRequestCompleted={this.state.callBackRequestCompleted}
              />
            <AutoSaveMessage
              message={autoSaveStatus}
              serviceTermAuthorableContent={serviceTermAuthorableContent}
              saveNowClickHandler={this.onAutoSaveHandler}
              dataSavedTime={this.state.dataSavedTime}
            />
            <AlreadySubmittedModal
              modalIsOpen={this.state.alreadySubmittedModalIsOpen}
              onCloseDialogBox={this.onCloseAlreadySubmittedModal}
              authorableContent={alreadySubmittedAuthorableContent}
            />              
          </div>
        </AppWrapper>
      );
    } else if (this.props.dataLoaded && this.props.isdnProduct === false) {
      const {
        customNet:
          {
            summary: ssmSummary,
            summaryTitle: ssmSummaryTitle,
          },
      } = this.props.authorableContent;
      const ssmHeader = {
        heading: ssmSummaryTitle,
        description: renderHTML(stripStartingAndEndingPTags(ssmSummary)),
      };
      return (
        <AppWrapper>
          <div className="ssm-homepage root-container container">
            <ViewHeader content={ssmHeader} />
          </div>
        </AppWrapper>
      );
    }
    return <Loader />;
  }
}
export default SSMHomePageView;
